/* eslint-disable @typescript-eslint/no-misused-promises */

// @ts-strict-ignore
/* eslint-disable no-prototype-builtins */

import { EventService } from 'rainbow-web-sdk/services/core/event.service';
import { MainService } from 'rainbow-web-sdk/services/core/main.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { ErrorHelperService } from 'rainbow-web-sdk/services/utilities/errorHelper.service';
import { SettingsService } from 'rainbow-web-sdk/services/core/settings.service';
import { AuthService } from 'rainbow-web-sdk/services/core/auth.service';
import { I18nService } from 'rainbow-web-sdk/services/core/i18n.service';
import { CompanyService } from 'rainbow-web-sdk/services/core/company.service';
import { XmppService } from 'rainbow-web-sdk/services/core/xmpp.service';

import anonymizer from 'rainbow-web-sdk/utils/anonymizer';
import { PromiseQueue } from 'rainbow-web-sdk/utils/promiseQueue';
import { ConnectedUserInit, ConnectedUserMedia, Contact } from 'rainbow-web-sdk/models/contact.model';
import { Observable, Subject, Subscription, filter } from 'rxjs';
import { RBEvent } from 'rainbow-web-sdk/models/event.model';
import { PersonalRoutine } from 'rainbow-web-sdk/models/personalRoutine.model';
import { TelephonyForward } from 'rainbow-web-sdk/models/telephonyForward.model';
import { getBinaryData, resizeImage } from 'rainbow-web-sdk/services/core/imageUtils.service';

import xmlParser from 'rainbow-web-sdk/utils/xmlParser';
import { EventableService, makeServiceEvent, RbServiceEvent, Service } from 'rainbow-web-sdk/services/service';
import { MaybeArray, subSeconds } from 'date-fns';
import { UserNetworkService, UserNetworkServiceRB } from 'rainbow-web-sdk/services/core/userNetwork.service';
import { DirectoryInternalSearchResults, DirectorySearchOptions } from './directorySearch.service';
import { User } from 'rainbow-web-sdk/models';
import { ConnectedUser, ConnectedUserProfile, ConnectedUserRB, DisplayOrder, UserCustomData, UserCustomStatus, UserEvents, UserExternalPresenceStatus, UserPresenceStatus, UsersByEmailsResult, WebCallCapabilities } from 'rainbow-web-sdk/models/user.model';
import { UserServiceEvents, UserServiceRB } from '../users/user.service';

/** @internal */
export const CONTACT_SVC = 'ContactService';

// Regular Expression (as manged by Rainbow server) for email address and phone number validation
const REGEXP_EMAIL_ADDRESS_FORMAT = /^[a-zA-ZÀ-ÿ0-9_'+-]+(\.[a-zA-ZÀ-ÿ0-9_'+-]+)*@[a-zA-ZÀ-ÿ0-9-]+(\.[a-zA-ZÀ-ÿ0-9-]+)*\.([a-zA-Z]{2,63})$/;
const REGEXP_PHONE_NUMBER_FORMAT = /^[0-9 \-+()./]{1,32}$/;

/**
 * The data to be sent when we want to update our user; NB If fileds are not present, they wont be updated on server !
 * A basic example:
 * ```ts
 * {    "firstName": "Hello",
 *       "lastName": "World",
 *       "title": "MR",
 *       "nickName": "Worldwide",
 *       "jobTitle": "Rainbow SDK guru",
 *       "country": "EN",
 *       "language": "en",
 *       "emails": [
 *           {
 *               "email": "work@work.en",
 *               "type": "work"
 *           },
 *           {
 *               "email": "home@home.en",
 *               "type": "home"
 *           }
 *       ],
 *       "phoneNumbers": [
 *           // corresponds to the phonePro property of contact
 *           {
 *               "number": "12345",
 *               "type": "work",
 *               "deviceType": "landline"
 *           },
 *
 *           // corresponds to the mobilePro property of contact
 *           {
 *               "number": "12534",
 *               "type": "work",
 *               "deviceType": "mobile",
 *               "isVisibleByOthers": false
 *           },
 *
 *           // corresponds to the phonePerso property of contact
 *           {
 *               "number": "111111",
 *               "type": "home",
 *               "deviceType": "landline",
 *               "isVisibleByOthers": false
 *           },
 *
 *           // corresponds to the mobilePerso property of contact
 *           {
 *               "number": "22222",
 *               "type": "home",
 *               "deviceType": "mobile",
 *               "isVisibleByOthers": false
 *           }
 *       ]
 *   }
 * ```
 */

/**
 * Contact service events sent to other services via sendEvent()
 * Can listen to it via contactService.subscribe() API
 * @internal
 * @eventProperty
 */
export enum ContactServiceEvents {

    /**
     * @eventProperty ON_CONNECTED_USER_PRESENCE_CHANGE
     * This RB event is sent when the presence of the connected user changes.
     * It's sent via the innerEvent system.
     * Used by conversation service to calculate the capabilities of contact in case of presence change of user.
     */
    ON_CONNECTED_USER_PRESENCE_CHANGE = 'ON_CONNECTED_USER_PRESENCE_CHANGE',

    /**
     * @eventProperty ON_USER_PRESENCE_CHANGE
     * This RB event is sent when the presence of any user changes.
     * It's sent via the innerEvent system.
     * Used by conversation service to calculate the capabilities of contact in case of presence change of user.
     */
    ON_USER_PRESENCE_CHANGE = 'ON_USER_PRESENCE_CHANGE',

    /**
     * @eventProperty ON_CONTACT_SERVICE_STARTED
     * This RB event is sent when the contact service is started and ready to be used.
     */
    ON_CONTACT_SERVICE_STARTED = 'ON_CONTACT_SERVICE_STARTED',

    /**
     * @eventProperty ON_CONNECTED_USER_ROSTER_CHANGE
     * This RB event is sent when a new contact is added or removed to/from the roster of the connected user.
     */
    ON_CONNECTED_USER_ROSTER_CHANGE = 'ON_CONNECTED_USER_ROSTER_CHANGE',

    /**
     * @eventProperty ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE
     * This RB event is sent when the custom status of the connected user changes.
     * It's sent via the innerEvent system.
     */
    ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE = 'ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE',

    /**
     * @eventProperty ON_USER_CUSTOM_STATUS_CHANGE
     * This RB event is sent when the custom status of any user changes.
     * It's sent via the innerEvent system.
     */
    ON_USER_CUSTOM_STATUS_CHANGE = 'ON_USER_CUSTOM_STATUS_CHANGE',

    /**
     * @eventProperty ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE
     * This RB event is sent when OXE  PREFERREDTRUNK of connected user changes.
     * It's sent via the innerEvent system.
     */
    ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE = "ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE"
}

/**
 * Contact service events sent to other services via sendEvent()
 * Can listen to it via contactService.events().subscribe() API
 * @internal
 * @eventProperty
 */
export interface IContactServiceEvents {

    /**
     * @eventProperty ON_CONNECTED_USER_PRESENCE_CHANGE
     * This RB event is sent when the presence of the connected user changes.
     * It's sent via the innerEvent system.
     * Used by conversation service to calculate the capabilities of contact in case of presence change of user.
     */
    ON_CONNECTED_USER_PRESENCE_CHANGE: Contact;

    /**
     * @eventProperty ON_USER_PRESENCE_CHANGE
     * This RB event is sent when the presence of any user changes.
     * It's sent via the innerEvent system.
     * Used by conversation service to calculate the capabilities of contact in case of presence change of user.
     */
    ON_USER_PRESENCE_CHANGE: Contact;

    /**
     * @eventProperty ON_CONTACT_SERVICE_STARTED
     * This RB event is sent when the contact service is started and ready to be used.
     */
    ON_CONTACT_SERVICE_STARTED: unknown;

    /**
     * @eventProperty ON_CONNECTED_USER_ROSTER_CHANGE
     * This RB event is sent when a new contact is added or removed to/from the roster of the connected user.
     */
    ON_CONNECTED_USER_ROSTER_CHANGE: {
        contact: Contact;
        action: string;
    };

    /**
     * @eventProperty ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE
     * This RB event is sent when the custom status of the connected user changes.
     * It's sent via the innerEvent system.
     */
    ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE: ConnectedUser;

    /**
     * @eventProperty ON_USER_CUSTOM_STATUS_CHANGE
     * This RB event is sent when the custom status of any user changes.
     * It's sent via the innerEvent system.
     */
    ON_USER_CUSTOM_STATUS_CHANGE: Contact;

    /**
     * @eventProperty ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE
     * This RB event is sent when OXE  PREFERREDTRUNK of connected user changes.
     * It's sent via the innerEvent system.
     */
    ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE: number;

}

/**
 * @internal
 * @eventProperty
 * Contact service internal events sent to other sevices via sendInnerEvent()
 * Should not be used by SDK user
 */
export enum ContactServiceInnerEvents {
    /**
     * @eventProperty ON_RAINBOW_ROOM_CONTACT_CREATED
     * This RB event is sent when a contact of type 'RainbowRoom' (Rainbow TV) is created.
     * It is sent to the rainbow TV service to link the RB Room/Tv object with the contact.
     */
    ON_RAINBOW_ROOM_CONTACT_CREATED = 'ON_RAINBOW_ROOM_CONTACT_CREATED',

    /**
     * @eventProperty ON_CONNECTED_USER_SETTINGS_UPDATED
     * This RB event is sent to detect a change on the user settings custom object.
     * At the moment it is only used for the 'ringingOnDnd' flag.
     */
    ON_CONNECTED_USER_SETTINGS_UPDATED = 'ON_CONNECTED_USER_SETTINGS_UPDATED',

    /**
     * @eventProperty ON_MOBILE_TELEPHONY_STATUS_CHANGE
     * This RBEvent is sent when there's a change in the mobile telephony status.
     */
    ON_MOBILE_TELEPHONY_STATUS_CHANGE = 'ON_MOBILE_TELEPHONY_STATUS_CHANGE',

    /**
     * @eventProperty ON_CONNECTED_USER_JID_RESOURCE_CHANGE
     * This RB event is sent when the list of my resources has changed.
     */
    ON_CONNECTED_USER_JID_RESOURCE_CHANGE = 'ON_CONNECTED_USER_JID_RESOURCE_CHANGE',

    /**
     * @eventProperty ON_CONNECTED_USER_AVATAR_CHANGE
     * This RBEvent is sent to detect a change on the user'avatar.
     * Used by Admin only at the moment.
     */
    ON_CONNECTED_USER_AVATAR_CHANGE = 'ON_CONNECTED_USER_AVATAR_CHANGE',

    /**
     * @eventProperty ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE
     * This RB event is sent when OXE  PREFERREDTRUNK of connected user changes.
     * It's sent via the innerEvent system.
     */
    ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE = "ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE"
}

/**
 * @internal
 */
export class ContactService extends Service implements EventableService<IContactServiceEvents> {

    // Services
    private eventService: EventService = EventService.getInstance();
    private settingsService: SettingsService = SettingsService.getInstance();
    private mainService: MainService = MainService.getInstance();
    private logger: LoggerService = LoggerService.getInstance();
    private errorHelperService: ErrorHelperService = ErrorHelperService.getInstance();
    private authService: AuthService = AuthService.getInstance();
    private i18nService: I18nService = I18nService.getInstance();
    private companyService: CompanyService = CompanyService.getInstance();
    private xmppService: XmppService = XmppService.getInstance();
    private networkService: UserNetworkServiceRB = UserNetworkServiceRB.getInstance();
    private userService: UserServiceRB = UserServiceRB.getInstance();

    // Observables/subscriptions/handlers management
    private readonly rxSubject = new Subject<RbServiceEvent<IContactServiceEvents>>();
    private readonly innerRxSubject: Subject<RBEvent> = new Subject<RBEvent>();
    private subscriptions: Subscription[] = [];
    private xmppConnectionSubscription: Subscription = null;
    private presentationModeEventHandlerCleaner: any = null;
    private contactConfigRef: any = null;
    private contactNotifyRef: any = null;

    // Contacts databases
    public contacts: Record<string, Contact> = {};
    public dbContacts: Record<string, Contact> = {};
    public jtelContacts: Record<string, Contact> = {};

    // Contact service public/private data
    public userNetwork?: UserNetworkService;
    public userContact?: ConnectedUserRB;
    public currentLanguage: string = null;

    private _displayOrder: DisplayOrder = null;
    private subscriptionPromiseQueue: PromiseQueue = PromiseQueue.create();
    private getContactPromises: Promise<Contact>[] = [];
    private lastActivityDatePromises: Promise<any>[] = [];

    private lastUpdatePresentationMode: boolean = null;
    private presentationModeTimeout: any = null;

    private apiConfigTTL: number = 0;
    private apiConfigTTLTimeout: any = null;

    // Presence properties
    private presentationModeActive: boolean = false;
    private awayStateActive: boolean = false;
    private busyState: any = { status: null, message: null };
    public manualState: boolean = false;
    public dndStateActivated: boolean = false;

    private getRosterTimeout: any = undefined;

    // ============================================================
    //                   LIFE CYCLE STUFF
    // ============================================================

    public static getInstance() {
        return Service.create(CONTACT_SVC, ContactService);
    }

    public static build() {
        return new ContactService();
    }

    private constructor() {
        super();
        this.userNetwork = this.networkService;
        this.userService.configure(this);
    }

    public async start(contactServiceConfig: any = null) {
        this.logger.info("[ContactService] === STARTING ===");

        // Handle settings
        this.currentLanguage = this.settingsService.getSetting('lang');
        this.settingsService.events('SETTINGS_UPDATED').subscribe(() => {
            this.currentLanguage = this.settingsService.getSetting('lang');
            this.setDisplayOrder(this.settingsService.getSetting('displayOrder') as DisplayOrder);

            for (const contact of this.getContacts()) {
                this.updateContactLastActivityDate(contact, contact.lastActivityDate.value);
            }
        });

        // Handle presence events
        this.subscriptions.push(this.xmppService.subscribeToContactEvents((event: RBEvent) => {
            try {
                switch (event.name) {
                    case 'ON_CONTACT_PRESENCE_EVENT': this.contactPresenceChangedHandler(event.data); break;
                    case 'ON_CONTACT_UPDATE_EVENT': this.onContactChangeEvent(event.data.from, event.data.type); break;
                    case 'ON_ROSTER_CHANGED_EVENT': this.subscriptionPromiseQueue.add(() => { return this.rosterChangedHandlerPromise(event.data); }); break;
                    case 'ON_CONTACT_CUSTOM_STATUS_UPDATE_EVENT':
                    case 'ON_CONTACT_CUSTOM_STATUS_DELETE_EVENT':
                        this.contactCustomStatusChangedHandler(event.data);
                        break;
                    default: break;
                }
            }
            catch (error) {
                this.logger.warn(`[ContactService] -- subscribeToContactEvents error ${error}`);
            }
        }));
        this.xmppService.contactServiceReady = true;

        // Handle calendar events

        if (this.presentationModeEventHandlerCleaner) { this.presentationModeEventHandlerCleaner(); }
        this.presentationModeEventHandlerCleaner = this.eventService.subscribe('ON_PRESENTATION_MODE_CHANGED_EVENT', (__event: any, status: string) => {
            this.onPresentationModeChangedEvent(status);
        });

        // await this.companyService.getCompanyById(this.userContact.company.id);

        // Create the user contact
        this.logger.info("[ContactService] Create userContact (" + this.xmppService.jid + ")");
        this.userContact = this.createConnectedUser();
        this.userContact.ask = null;
        this.userContact.subscription = null;

        // Attach xmpp information (check)
        this.userContact.id = this.xmppService.jid;
        this.userContact.jid = this.xmppService.jid;
        this.userContact.fullJid = this.xmppService.fullJid;

        // Update contact with user data auth information
        this.userContact.language = this.currentLanguage;
        this.userContact.updateFromUserData(this.authService.loggedInUser);
        this.updateContactRichStatus(this.userContact);

        // Store this contact in contact maps
        this.dbContacts[this.userContact.dbId] = this.userContact;
        this.contacts[this.userContact.id] = this.userContact;
        this.jtelContacts[this.userContact.jidtel] = this.userContact;

        const userDataToUpdate: any = {};

        if (!this.authService.loggedInUser.language) { userDataToUpdate.language = this.settingsService.getAppliLanguageCodeForServer(); }

        // User settings
        const settings: any = await this.getUserSettings();

        // Push to talk, set default values
        let shouldUpdatecustomData: boolean = false;
        const pushToTalkEnabled = this.userContact.customData.pushToTalkEnabled;
        if (pushToTalkEnabled === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.pushToTalkEnabled = false;
        }

        const pushToTalkKey = this.userContact.customData.pushToTalkKey;
        if (pushToTalkKey === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.pushToTalkKey = `Shift`;
        }

        const pushToTalkDelay = this.userContact.customData.pushToTalkDelay;
        if (pushToTalkDelay === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.pushToTalkDelay = 0;
        }

        const enablePushToTalkTone = this.userContact.customData.enablePushToTalkTone;
        if (enablePushToTalkTone === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.enablePushToTalkTone = false;
        }

        const hasSecondRinger = this.userContact.customData.hasSecondRinger;
        if (hasSecondRinger === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.hasSecondRinger = false;
        }

        const openPopoutOnAnswerCall = Boolean(this.userContact.customData.openPopoutOnAnswerCall);
        this.settingsService.setSetting("openPopoutOnAnswerCall", String(openPopoutOnAnswerCall));

        const endCallOnClosePopout = Boolean(this.userContact.customData.endCallOnClosePopout);
        this.settingsService.setSetting("endCallOnClosePopout", String(endCallOnClosePopout));

        const notificationDurationValue = this.userContact.customData.notificationDurationValue;
        if (notificationDurationValue) {
            this.settingsService.setSetting("notificationDurationValue", String(notificationDurationValue));
        }
        else {
            //check the default company value
            if (this.authService.loggedInUser.imPopupDuration) {
                this.settingsService.setSetting("notificationDurationValue", String(this.authService.loggedInUser.imPopupDuration));
            }
        }
        //in case of Firefox, disable auto pop-out globally
        if (navigator.userAgent && navigator.userAgent.indexOf("Firefox") > -1) {
            this.settingsService.setSetting("openPopoutOnAnswerCall", String(false));
        }

        const forwardInternalValue = this.userContact.customData.forwardInternalValue;
        if (forwardInternalValue === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.forwardInternalValue = ``;
        }

        const forwardInternalContactId = this.userContact.customData.forwardInternalContactId;
        if (forwardInternalContactId === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.forwardInternalContactId = ``;
        }

        const forwardExternalValue = this.userContact.customData.forwardExternalValue;
        if (forwardExternalValue === undefined) {
            shouldUpdatecustomData = true;
            this.userContact.customData.forwardExternalValue = ``;
        }

        if (shouldUpdatecustomData) userDataToUpdate.customData = this.userContact.customData;

        if (Intl?.DateTimeFormat?.().resolvedOptions) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone && timezone !== this.userContact.timezone) {
                this.logger.info("[ContactService] update user timezone from : " + this.userContact.timezone + " to : " + timezone);
                //update timezone at start-up
                userDataToUpdate.timezone = timezone;
            }
        }

        if (this.userContact.modifyProfileEnabled && Object.keys(userDataToUpdate).length > 0) this.updateUserProfile(userDataToUpdate);

        // Update the display order with data received from server (for all contacts already retrieved)
        this.setDisplayOrder(settings.displayOrder);

        // User company
        this.userContact.company = await this.companyService.getCompanyById(this.userContact.company.id);
        this.userContact.companyFeatures = await this.companyService.getCompanyFeatures(this.userContact.company.id);

        //manage splash screen settings
        this.manageSplashScreen();
        // Update userContact from company data
        this.userContact.alertNotificationEnabledForMyCompany = this.userContact.companyFeatures.alertNotifAllowed;
        if (this.userContact.mainStorage === 'same_than_company') this.userContact.mainStorage = this.userContact.company['mainStorage'];
        if (this.userContact.useRainbowStorage === 'same_than_company') this.userContact.useRainbowStorage = this.userContact.company['useRainbowStorage'];
        if (this.userContact.useExternalStorage === 'same_than_company') this.userContact.mainStorage = this.userContact.company['useExternalStorage'];

        // Attach XMPP event handler
        this.attachHandlers();

        // API to be called before we start the services, as the FETCH configuration will be updated !
        await this.getApiConfigurationFromServer();

        // User network
        if (!contactServiceConfig?.skipNetwork) await this.getNetwork();

        // Handle application state events
        this.subscriptions.push(this.mainService.appActive.subscribe((appActive: boolean) => {
            this.logger.info("[ContactService] AppActive changed : " + appActive);
            if (!appActive && this.userContact && this.userContact.status === "online") { this.awayStateActive = true; }
            if (appActive && this.awayStateActive) { this.awayStateActive = false; }
            if (this.mainService.appActiveAutoAway && this.userContact.status !== "offline") { this.updatePresence(true); }
            return true;
        }));

        // Handle missed presence
        this.getMissedPresenceMessages();

        // Attach event listener
        if (this.xmppConnectionSubscription) { this.xmppConnectionSubscription.unsubscribe(); }
        this.xmppConnectionSubscription = this.xmppService.subscribeToConnectionEvents((event: RBEvent) => { this.onConnectionStateChangeEvent(event); });

        this.logger.info("[contactService] === STARTED ===");
        this.sendContactUpdateEvent(this.userContact, "update");
        this.sendEvent(ContactServiceEvents.ON_CONTACT_SERVICE_STARTED);

        this.networkService.start(this);
    }

    public async stop() {
        this.logger.info("[ContactService] == STOPPING ==");

        this.apiConfigTTL = 0;
        if (this.apiConfigTTLTimeout) {
            clearTimeout(this.apiConfigTTLTimeout);
            this.apiConfigTTLTimeout = null;
        }
        if (this.getRosterTimeout) { clearTimeout(this.getRosterTimeout); this.getRosterTimeout = undefined; }

        this.mainService.apiHeadersConfiguration = [];

        this.userContact = null;
        this.contacts = {};
        this.dbContacts = {};
        this.jtelContacts = {};
        this.presentationModeActive = false;
        this.awayStateActive = false;
        this.busyState = { status: null, message: null };
        this.manualState = false;
        this.dndStateActivated = false;

        if (this.subscriptions) { this.subscriptions.forEach((subscription: Subscription) => { subscription.unsubscribe(); }); }
        if (this.xmppConnectionSubscription) { this.xmppConnectionSubscription.unsubscribe(); }
        if (this.presentationModeEventHandlerCleaner) { this.presentationModeEventHandlerCleaner(); this.presentationModeEventHandlerCleaner = null; }
        if (this.contactConfigRef) { this.xmppService.deleteHandler(this.contactConfigRef); this.contactConfigRef = null; }
        if (this.contactNotifyRef) { this.xmppService.deleteHandler(this.contactNotifyRef); this.contactNotifyRef = null; }

        this.logger.info("[ContactService] == STOPPED ==");

        this.networkService.stop();
    }

    public reconnect() {
        this.logger.info("[ContactService] == RECONNECT ==");
        this.updateUserContactFullJid();
        this.networkService.reconnect();
        this.getApiConfigurationFromServer();

        //update company splash screen, just in case
        this.updateUserContactCompany();
        this.logger.info("[ContactService] == RECONNECTED ==");

        //update user roster, but not immeadiately
        if (this.getRosterTimeout) { clearTimeout(this.getRosterTimeout); this.getRosterTimeout = undefined; }
        this.getRosterTimeout = setTimeout(() => {
            this.refreshUserNetwork();
        }, 30000);
    }

    private async updateUserContactCompany() {
        try {
            this.userContact.company = await this.companyService.getCompanyById(this.userContact.company.id, true);
            //manage splash screen settings
            this.manageSplashScreen();
        }
        catch (error) {
            this.logger.warn(`[ContactService] updateUserContactCompany failed -- ${error}`);
        }
    }

    private attachHandlers() {
        this.logger.info("[ContactService] AttachHandlers");
        if (this.contactConfigRef) { this.xmppService.deleteHandler(this.contactConfigRef); this.contactConfigRef = null; }
        this.contactConfigRef = this.xmppService.addHandler((stanza) => { this.onUserManagementEvent(stanza); return true; }, null, "message", "management");
        if (this.contactNotifyRef) { this.xmppService.deleteHandler(this.contactNotifyRef); this.contactNotifyRef = null; }
        this.contactNotifyRef = this.xmppService.addHandler((stanza) => { this.onNotifyEvent(stanza); return true; }, "urn:xmpp:broadcast:0", "message", "headline");
    }

    private async onNotifyEvent(stanza) {
        try {
            const stanzaElem = xmlParser(stanza);
            const updateProfileElem = stanzaElem.find('update-profile');
            if (updateProfileElem?.length) {
                const userId = updateProfileElem.attr('user_id');
                const userJid = updateProfileElem.attr('jid');
                let contact;
                if (userId) { try { contact = await this.getContact(userId); } catch (error) { this.logger.warn(`[ContactService] onNotifyEvent error -- cannot find user with ${userId} -- ${error}`); } }
                if (userJid && !contact) { try { contact = await this.getContact(userJid); } catch (error) { this.logger.warn(`[ContactService] onNotifyEvent error -- cannot find user with ${userJid} -- ${error}`); } }

                if (contact) {
                    this.logger.info(`[ContactService] onNotifyEvent for ${userJid} ${contact?.nameForLogs}`);
                    //update contact
                    const firstname = updateProfileElem.find("firstname").text();
                    const lastname = updateProfileElem.find("lastname").text();
                    if (firstname || lastname) {
                        contact.updateName(firstname, lastname);
                    }

                    this.logger.info(`[ContactService] onNotifyEvent ${userJid} is now updated to ${contact?.nameForLogs}`);
                }
            }
        }
        catch {
            this.logger.error(`[ContactService] onNotifyEvent error`);
        }
    }

    private manageSplashScreen() {
        if (this.userContact.company?.selectedSplashScreen?.uploadedUsed && this.userContact.company?.selectedSplashScreen.companyId) {
            //use new splash screen
            const rand = this.userContact.company?.selectedSplashScreen?.lastUpdateDate ? Date.parse(this.userContact.company?.selectedSplashScreen?.lastUpdateDate) : Math.floor(Math.random() * 100);
            localStorage.setItem("splashScreen", `${config.restServerUrl}/api/splashscreen/${this.userContact.company?.selectedSplashScreen.companyId}?size=2048&random=${rand}`);
            localStorage.removeItem("splashScreenLegend");
            localStorage.removeItem("splashScreenAuthor");
        }
        else {
            //reset splash screen to default one
            localStorage.setItem("splashScreen", "../../cacheV2/images/login/GrossesGouttes-min.jpg");
            localStorage.setItem("splashScreenLegend", "Drops");
            localStorage.setItem("splashScreenAuthor", "F.Meyer");
        }
    }

    private async getApiConfigurationFromServer() {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/settings/apis`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'GET', headers });
            if (!response.ok) throw (response);
            const responseData = await response.json();
            this.logger.info(`[ContactService] getApiConfigurationFromServer success`);

            const httpUrls = [];
            if (responseData?.data?.additionalHeaders) {
                responseData.data.additionalHeaders.forEach((additionalHeader: any) => {
                    additionalHeader.match.forEach((obj) => {
                        httpUrls.push({
                            url: obj.url.replace("*", ""),
                            method: obj.method,
                            headers: additionalHeader.headers
                        });
                    });
                });
            }

            this.mainService.apiHeadersConfiguration = httpUrls;

            this.apiConfigTTL = responseData.data.ttl;
            if (this.apiConfigTTL) {
                this.apiConfigTTLTimeout = setTimeout(() => {
                    this.apiConfigTTL = 0;
                    this.getApiConfigurationFromServer();
                }, this.apiConfigTTL * 1000);
            }
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getApiConfigurationFromServer');
            this.logger.error(errorInfo.message);
        }
    }

    private onConnectionStateChangeEvent(event: RBEvent) {
        if (event.name === "ON_XMPP_DISCONNECTED" && this.userContact) {
            // Clear all the resources for my account
            this.userContact.resources = {};
            Object.keys(this.contacts).forEach((key: string) => {
                const contact: Contact = this.contacts[key];
                if (!contact.isBot) {
                    contact.resources = {};
                    if (contact.status !== "unknown" && contact.subscription !== "none") { contact.status = "offline"; contact.imStatusStamp = []; }
                }
            });
            this.presentationModeActive = false;
            this.awayStateActive = false;
            // this.busyState = { status: null, message: null };
            // this.manualState = false;

            this.apiConfigTTL = 0;
            if (this.apiConfigTTLTimeout) {
                clearTimeout(this.apiConfigTTLTimeout);
                this.apiConfigTTLTimeout = null;
            }

            // Clear all cached contacts custom status
            Object.keys(this.dbContacts).forEach((key: string) => {
                const contact: Contact = this.dbContacts[key];
                contact.customStatus = null;
            });
        }
    }

    /**
     * Update my fullJid with the new after a reconnection
     */
    private updateUserContactFullJid() {
        //
        this.userContact.fullJid = this.xmppService.fullJid;
        this.attachHandlers();
    }

    // ============================================================
    //          EVENT LISTENERS ( Handling of events)
    // => Includes XMPP ands Subscription events
    // ============================================================

    private async contactPresenceChangedHandler(attr: any) {
        const resource = this.getResourceFromJid(attr.jid);
        // Ignore calendar presence
        if (resource === "calendar") { return; }
        if (resource === "presence") { return; }

        // Get the im jid (attr.jid is potentially a telephony jid)
        const jidIm = this.getImJid(attr.jid);
        if (!jidIm) { return; }

        // Ignore room "caps" presence message
        if (jidIm.startsWith("room")) { return; }

        // Get or create the associated contact
        const contact = await this.getOrCreateContact(jidIm);
        const isUserContact = this.isUserContact(contact);

        // Update telephony status
        if (this.isTelJid(attr.jid)) {
            this.logger.info("[ContactService] Update telephony presence (" + jidIm + ") source: " + resource);
            this.logger.info("[ContactService] Update telephony presence (" + jidIm + ") msg: " + attr.message + " / status: " + attr.status);
            this.updateContactTelephonyStatus(contact, attr, isUserContact);
        }

        // Update im presence status
        else {
            this.logger.info("[ContactService] Update im presence contact (" + jidIm + ") status: " + attr.status + " " + attr.stamp);

            // Dispatch the auto mode to everybody if user already exists
            if (this.isUserContact(contact) && attr.message === "mode=auto" && contact.status !== "online" && contact.resources.hasOwnProperty(attr.jid) && attr.jid !== contact.fullJid) {
                // Not in PABX call
                if (contact.telStatus !== "EVT_SERVICE_INITIATED" && contact.telStatus !== "EVT_ESTABLISHED") {
                    // If the current ressource is already online, do not send a message
                    if (contact.resources[contact.fullJid] && contact.resources[contact.fullJid].show === "online") {
                        this.logger.info("[ContactService] Current ressource is already online, ignore message!");
                    }
                    else {
                        // If in manual state, we should leave it
                        if (this.manualState) {
                            this.logger.info("[ContactService] User is in manual state, leave it");
                            this.setUserContactStatus("online", "mode=auto");
                        }

                        // If in a WEBRTC call on this device, update the presence
                        if (this.busyState && this.busyState.status === "dnd" && this.userContact.status !== "busy") {
                            this.logger.info("[ContactService] User is in call, re-update presence state");
                            setTimeout(() => { this.updatePresence(true); }, 500);
                        }
                    }
                }
            }
            this.updateContactIMStatus(contact, attr, this.isUserContact(contact));
            this.updateLastActivity(contact);
        }
    }

    private onContactChangeEvent(jid: string, type: string) {
        this.logger.info("[ContactService] onContactChangeEvent event: " + " || status: " + jid + " || type: " + type);
        setTimeout(async () => {
            const contact = this.getContactFromCacheByJid(jid);
            if (contact) {
                await this.updateContactFromServer(contact);
                if (this.isUserContact(contact)) {
                    this.logger.debug("[ContactService] onContactChangeEvent userContact phonePbx '" + contact.phonePbx + "' ccdAgent : " + JSON.stringify(contact.ccdAgent));
                }
                this.userService.sendEvent(UserServiceEvents.ON_USER_CHANGED, { user: contact as User });
                if (type === "avatar") {
                    contact.updateAvatar(256, true);
                    this.sendContactUpdateEvent(contact, "update");
                    // Send update avatar event
                    const isMe = this.isUserContact(contact);
                    if (isMe) { this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_AVATAR_CHANGE); }
                }
            }
        }, 500);
    }

    private async rosterChangedHandlerPromise(attr: any): Promise<any> {
        try {
            // Ignore telephony events for the moment
            if (this.isTelJid(attr.jid)) { this.logger.debug("[ContactService] Contact changed (" + attr.jid + ") ignored"); return; }

            // Get or create the associated contact
            const contact = await this.getOrCreateContact(attr.jid);
            let action = "";
            if (attr.subscription === 'remove' || attr.subscription === 'none') {
                contact.ask = 'none';
                contact.subscription = 'none';
                if (contact.roster) {
                    contact.roster = false;
                    action = "remove";
                }
            }
            else {
                contact.ask = attr.ask;
                contact.subscription = attr.subscription;
                if (!contact.roster) {
                    contact.roster = true;
                    action = "added";
                }
                if (attr.subscription === "both") { this.updatePresence(true); }
            }
            this.updateContactRichStatus(contact);

            // Send contact updated event
            this.sendContactUpdateEvent(contact, "roster");

            if (action) {
                this.sendEvent(ContactServiceEvents.ON_CONNECTED_USER_ROSTER_CHANGE, { contact, action });
            }

            this.logger.info("[ContactService] rosterChangedHandler - contact " + attr.jid + " changed (" + attr.ask + ", " + attr.subscription + ") success");
        }
        catch (error) {
            this.logger.error("[ContactService] rosterChangedHandler - contact " + attr.jid + " failure - " + error.message);
        }
    }

    private async onUserManagementEvent(stanza: any) {
        try {
            // Handle userSettings update event
            const stanzaElem = xmlParser(stanza);
            const userSettingsElem = stanzaElem.find("usersettings");
            if (userSettingsElem.attr("action") === "update") {
                this.logger.info("[ContactService] onUserManagementEvent - usersettings updated");

                const settingsElem = stanzaElem.find("setting");
                if (settingsElem.length) {
                    const settingsName = settingsElem.attr("name");
                    const managedSettings = {
                        ringingOnDnd: 'ringingOnDnd',
                        protectionAgainstMailTypeOffline: 'protectionAgainstMailTypeOffline',
                        activeAlarm: 'activeAlarm',
                        activeNotif: 'activeNotif',
                        autoAnswerByDeviceType: 'autoAnswerByDeviceType',
                        autoAnswer: 'autoAnswer',
                        applyMsTeamsPresence: 'applyMsTeamsPresence',
                        presence: 'presence',
                        displayNameOrderFirstNameFirst: 'displayOrder'
                    };

                    const isSettingManaged: boolean = settingsName in managedSettings;

                    if (isSettingManaged) {
                        const localStorageSettingName = managedSettings[settingsName];
                        let value: string = settingsElem.attr("value");

                        // If necessary, the typing difference between the Web Client and the server settings must be managed.
                        if (localStorageSettingName === "displayOrder") {
                            value = (value === "true") ? "FL" : "LF";
                        }
                        this.settingsService.setSetting(localStorageSettingName, value);

                        // Post-Processing (To be done after setSetting)
                        if (settingsName === "presence") {
                            //manage update of the user presence settings
                            this.manageUserSettingsPresenceChange(value);
                        }
                        // Mainly used to update contact display names.
                        if (localStorageSettingName === "displayOrder") {
                            this.setDisplayOrder(value as DisplayOrder);
                        }
                    }
                    else {
                        await this.sendPresenceFromConfiguration();
                    }

                    //send update settings event for user
                    this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_SETTINGS_UPDATED, settingsName);
                    return true;
                }
            }

            // Handle userPassword update event
            const userPasswordElem = stanzaElem.find("userpassword");
            if (userPasswordElem.attr("action") === "update") {
                this.logger.info("[ContactService] onUserManagementEvent - userPassword updated");
                if (!this.xmppService.changePasswordInfo) { this.xmppService.changePasswordInfo = { fromThirdParty: true }; }
                return true;
            }

            // Handle userPassword update event
            // const userAccountElem = xmlParser(stanza).find("useraccount");
            // if (userAccountElem.length && userAccountElem.attr("action") === "update") {
            //     this.logger.info("[ContactService] onUserManagementEvent - userAccount updated");
            //     const contactDbId = userAccountElem.attr("id");

            //     this.getContactByDBId(contactDbId, true);

            //     return true;
            // }

            const customStatusElem = stanzaElem.find("customStatus");
            if (customStatusElem?.length) {
                const action = customStatusElem.attr('action');
                switch (action) {
                    case 'create': {
                        const contentText = customStatusElem.find('content')?.text();
                        this.logger.info("[ContactService] onUserManagementEvent - customStatus created");
                        try {
                            this.userContact.updateCustomStatus(JSON.parse(contentText));
                        } catch {
                            this.logger.info(`[ContactService] onUserManagementEvent - customStatus created - JSON malformed`);
                        }
                        break;
                    }
                    case 'update': {
                        const contentText = customStatusElem.find('content')?.text();
                        this.userContact.updateCustomStatus(JSON.parse(contentText));
                        this.logger.info("[ContactService] onUserManagementEvent - customStatus updated");
                        break;
                    }
                    case 'expired':
                    case 'delete': {
                        this.userContact.updateCustomStatus(JSON.parse(null));
                        this.logger.info("[ContactService] onUserManagementEvent - customStatus deleted");
                        break;
                    }
                    default:
                        break;
                }
                this.sendInnerEvent(ContactServiceEvents.ON_CONNECTED_USER_CUSTOM_STATUS_CHANGE, this.userContact);
                this.userContact?.sendEvent(UserEvents.ON_CUSTOM_STATUS_CHANGE);
            }

            return true;
        }
        catch { return true; }
    }

    private async contactCustomStatusChangedHandler(attr: { jid: string; customStatus?: string; }) {
        const jidIm = this.getImJid(attr.jid);
        // Get or create the associated contact
        const contact = await this.getOrCreateContact(jidIm);
        const customStatus = attr.customStatus;
        if (customStatus) {
            // update or creation
            contact.customStatus = JSON.parse(customStatus);
        } else {
            // deletion
            contact.customStatus = null;
        }
        this.sendInnerEvent(ContactServiceEvents.ON_USER_CUSTOM_STATUS_CHANGE, contact);
        contact.sendEvent(UserEvents.ON_CUSTOM_STATUS_CHANGE);
    }

    //  PRESENTATION MODE event management
    // ------------------------------------------
    private onPresentationModeChangedEvent(status: string): void {
        if (status === "active") { this.presentationModeActive = true; }
        else if (status === "disable") { this.presentationModeActive = false; }
        if (this.lastUpdatePresentationMode === null) {
            this.logger.debug(`[ContactService] onPresentationModeChangedEvent '${status}' request presence update`);
            this.lastUpdatePresentationMode = this.presentationModeActive;
            this.updatePresence();
        }
        this.startUpdatePresentationModeRefreshTimer();
    }

    private startUpdatePresentationModeRefreshTimer() {
        this.logger.debug("[ContactService] startUpdatePresentationModeRefreshTimer");
        if (this.presentationModeTimeout !== null) {
            clearTimeout(this.presentationModeTimeout); this.presentationModeTimeout = null;
        }
        this.presentationModeTimeout = setTimeout(() => {
            this.logger.debug("[ContactService] startUpdatePresentationModeRefreshTimer interval reach");
            if (this.lastUpdatePresentationMode !== this.presentationModeActive) {
                this.logger.debug("[ContactService] startUpdatePresentationModeRefreshTimer interval - request presence update");
                this.lastUpdatePresentationMode = this.presentationModeActive;
                this.updatePresence();
                this.startUpdatePresentationModeRefreshTimer();
            }
            else {
                this.logger.debug("[ContactService] startUpdatePresentationModeRefreshTimer interval - no presence update needed");
                this.lastUpdatePresentationMode = null;
            }
        }, 1000);
    }

    // ============================================================
    //                 PUBLIC METHODS FOR UCAAS ONLY
    //    ALSO USED by user.model for SDKv2 purposes
    // ============================================================

    /**
     * Update the user's password
     * @param oldPassword - The old password
     * @param newPassword - The new password
     * @param async - [optional] if TRUE, the resolve of this API will be done once the change is taken into account also on XMPP side; Default value is FALSE
     */
    public updateConnectedUserPassword(oldPassword: string, newPassword: string, async: boolean = false): Promise<User> {
        return new Promise((resolve: any, reject: any) => {
            const login = this.userContact.loginEmail;
            this.xmppService.changePasswordInfo = { resolve: async ? resolve : null, login, newPassword };
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.authService.userId}/change-password`;
            const headers = this.authService.getPostHeader();
            fetch(url, { method: 'PUT', headers, body: JSON.stringify({ oldPassword, newPassword }) })
                .then((response: Response) => {
                    if (!response.ok) throw (response);
                    if (!async) resolve();
                })
                .catch(async (error: any) => {
                    this.xmppService.changePasswordInfo = null;
                    const errorInfo = await this.errorHelperService.getErrorInfo(error, 'updateUserPassword');
                    this.logger.error(errorInfo.message);
                    reject(errorInfo.error);
                });
        });
    }

    /**
     * Update the current user avatar
     * @param base64Image - Base64 image to be uploaded
     */
    public async setAvatar(base64Image: string): Promise<User> {
        const oldImage = this.userContact.avatar;
        try {
            this.logger.info('[contactService] Push avatar image');
            const resizedImage = await resizeImage(base64Image, 512, 512);
            const binaryData = getBinaryData(resizedImage);
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.userContact.dbId}/avatar`;
            const headers = this.authService.getPostHeader("image/" + binaryData.type);
            const response: Response = await fetch(url, { method: 'POST', headers, body: binaryData.data });
            if (!response.ok) throw (response);
            await response.json();
            // Send update avatar event
            const isMe = this.isUserContact(this.userContact);
            if (isMe) { this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_AVATAR_CHANGE); }
            return this.userContact;
        }
        catch (error) {
            this.userContact.avatar = oldImage;
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'setAvatar');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     *  Remove the current user custom avatar (reset to default avatar)
     */
    public async removeAvatar(): Promise<User> {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.userContact.dbId}/avatar`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'DELETE', headers });
            if (!response.ok) throw (response);
            this.logger.info('[contactService] removeAvatar -- SUCCESS');
            this.userContact.avatar = this.userContact.avatarSrc = null;
            // Send update avatar event
            const isMe = this.isUserContact(this.userContact);
            if (isMe) { this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_AVATAR_CHANGE); }
            return this.userContact;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'removeAvatar');
            this.logger.error(`[contactService] ${errorInfo.message}`);
            throw errorInfo.error;
        }
    }

    public async setUserSettings(params: any) {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.userContact.dbId}/settings`;
            const headers = this.authService.getPostHeader();
            const response: Response = await fetch(url, { method: 'PUT', headers, body: JSON.stringify(params) });
            if (!response.ok) throw (response);
            this.logger.info(`[contactService] SetUserSettings ${JSON.stringify(params)} -- success`);
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'setUserSettings');
            this.logger.error(errorInfo.message);
            if (errorInfo.error.errorDetailsCode && errorInfo.error.errorDetailsCode === 403153) {
                //reset back to online presence
                this.setUserContactStatus("online", "mode=auto");
                this.mainService.showGlobalPopupMessage({ popupTitle: "presence", popupBody: "changePresenceDisabled", okLabel: "ok" });
            }

            throw errorInfo.error;
        }
    }

    /**
     * Get/Set the user setting for display order of first and last names
     */
    public getDisplayOrder(): DisplayOrder { return this._displayOrder; }
    public setDisplayOrder(displayOrder: DisplayOrder) {
        this._displayOrder = displayOrder;
        Object.keys(this.contacts).forEach((key) => {
            const contact: Contact = this.contacts[key];
            contact.displayOrder = displayOrder;
            contact.computeDisplayName();
        });
    }
    /**
     * Checks that an email address is valid.
     * @param emailAddress - The email address to check
     */

    public isEmailAddressValid(emailAddress: string): boolean {
        if (emailAddress.match(REGEXP_EMAIL_ADDRESS_FORMAT)) {
            return true;
        }

        return false;
    }

    /**
     * Checks that a phone number is valid.
     * @param phoneNumber - The phone number to check
     */
    public isPhoneNumberValid(phoneNumber: string): boolean {
        if (phoneNumber.match(REGEXP_PHONE_NUMBER_FORMAT)) {
            return true;
        }

        return false;
    }

    // ============================================================
    //                 PUBLIC METHODS FOR UCAAS ONLY !!
    // ============================================================

    // ----------------------------------
    //      OBSERVABLE/EVENTS STUFF
    // ----------------------------------

    /**
     * Subscribe to updates from the service (all events are of RBEvent type \{name: string, data:any \});
     * Here's a list of events received :
     * name: 'ON_CONTACT_SERVICE_STARTED
     * NB There might be some events that are not documented here, they're sent on updates of different properties of the contact.
     * @param handler - The call-back function that will be subscribed to the RxJS subject
     * @param eventNames - (optional) array of event to listen
     */
    public subscribe(handler: (event: RbServiceEvent<IContactServiceEvents>) => any, eventNames?: MaybeArray<keyof IContactServiceEvents>): Subscription {
        const observable = eventNames
            ? this.rxSubject.pipe(filter((event) => {
                if (eventNames instanceof Array) return eventNames.includes(event.name);
                return event.name === eventNames;
            }))
            : this.rxSubject;

        return observable.subscribe((event) => {
            try { handler(event); }
            catch (error) { this.logger.error(`[ContactService] subscribe () -- error -- ${error.message}`); }
        });
    }

    public subscribeToInnerEvents(handler: any): Subscription {
        return this.innerRxSubject.subscribe(handler);
    }

    private sendEvent<const EventNames extends keyof IContactServiceEvents>(name: EventNames, data: IContactServiceEvents[EventNames] = null) {
        this.rxSubject.next(RBEvent.create(name, data));
    }

    public events<const EventNames extends keyof IContactServiceEvents>(...eventNames: EventNames[]) {
        return makeServiceEvent(this.rxSubject, ...eventNames);
    }

    private sendInnerEvent(name: string, data: any = null) {
        this.innerRxSubject.next(RBEvent.create(name, data));
    }

    private sendContactUpdateEvent(contact: Contact, eventName: string = "update"): void {
        //wiil be removed soon, for debugging reasons :)
        this.logger.debug(`[contactService] sendContactUpdateEvent called --- ${eventName} -- ${contact.nameForLogs}`);
        contact.rxSubject.next({ name: eventName, data: contact });
    }

    // ------------------------------------------------------------------------
    //      GET contact(s) STUFF
    // => All possible ways to get all contacts, some contacts by an identifier
    //    (id/jid/dbId/jidTel)or by a data for communication (email, phone number...)
    // ------------------------------------------------------------------------

    /**
     * Get all contacts stored for the current user;
     */
    public getContacts(): Contact[] {
        return Object.keys(this.contacts).map((key: string) => { return this.contacts[key]; });
    }

    /**
     * Async method which get a contact.
     * The contact is first search in service cache then server side.
     * @param contactRef - a contact jid or contact dbId or contact jid tel
     */
    public async getContact(contactRef: string): Promise<Contact | undefined> {
        let contact: Contact | undefined;
        try {
            if (!contactRef) return undefined;
            contact = this.getContactFromCache(contactRef);
            if (!contact) {
                if (contactRef.indexOf("@") === -1) { contact = await this.getContactByDBId(contactRef, true); }
                else {
                    contactRef = this.getImJid(contactRef);
                    if (contactRef) { contact = await this.getContactByJid(contactRef, true); }
                }
            }
            return contact;
        }
        catch (error) {
            this.logger.error(`[ContactService] getContact -- FAILURE -- ${error.message}`);
        }
        return contact;
    }

    /**
     * Get a contact in service cache by his dbId
     * @param dbId - the dbID of the contact to be found
     */
    public getContactFromCacheById(dbId: string): Contact | undefined { return this.dbContacts[dbId]; }

    /**
     * Get contact in cache by his jid
     * @param id - the jid of the contact to be found
     */
    public getContactFromCacheByJid(jid: string): Contact { return (this.isUserContactJid(jid)) ? this.userContact : this.contacts[jid]; }

    /**
     * Get a contact by his jid tel
     * @param jidTel - the jid tel of the contact to be found
     */
    public getContactByJidTel(jidTel: string): Contact { return this.jtelContacts[jidTel]; }

    /**
     * Sync method which get a contact.
     * The contact is searched in service cache
     * @param contactRef - A contact jid or contact dbId or contact jid tel
     */
    public getContactFromCache(contactRef: string): Contact | undefined {
        let contact: Contact | undefined;
        contact = this.getContactFromCacheByJid(contactRef);
        if (!contact) { contact = this.getContactFromCacheById(contactRef); }
        if (!contact) { contact = this.getContactByJidTel(contactRef); }

        return contact;
    }

    public async getContactById(id: string, server: boolean = false): Promise<Contact | undefined> {
        try {
            // Search in cache
            this.logger.info(`[ContactService] getContactById(${id})`);

            if (this.dbContacts[id]) return this.dbContacts[id];
            if (server) { throw new Error("Not yet implemented"); }
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactById');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
        return undefined;
    }

    /**
     * Get a contact by dbId
     * If not found, the contact will be searched on server.
     * @param dbId - the dbId of the contact to be found
     * @param force - [optional] if TRUE, this will force an update of the contact from the server
     */
    public getContactByDBId(dbId: string, force: boolean = false): Promise<Contact> {
        // Check if the contact already exists
        const existingContact = this.dbContacts[dbId];
        if (!force && existingContact) { return Promise.resolve(existingContact); }

        // Check if a request for this contact is already lauched
        if (!this.getContactPromises[dbId]) {
            this.getContactPromises[dbId] = new Promise<Contact>((resolve, reject) => {
                this.getContactByDbIdInner(dbId)
                    .then((contact) => { resolve(contact); })
                    .catch((error) => { reject(error); })
                    .finally(() => { delete this.getContactPromises[dbId]; });
            });
        }
        return this.getContactPromises[dbId];
    }

    private async getContactByDbIdInner(dbId: string): Promise<Contact> {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${dbId}?format=full`;
            const response: Response = await fetch(url, { method: 'GET', headers: this.authService.getRequestHeader() });
            if (!response.ok) { throw (response); }
            const contactData = (await response.json()).data;
            //check if contact exists
            const existingContact = this.contacts[contactData.jid_im] ? this.contacts[contactData.jid_im] : this.dbContacts[dbId];
            const contact = existingContact ? existingContact : this.createBasicContact(contactData.jid_im, null, false);
            contact.updateFromUserData(contactData);
            this.contacts[contact.id] = contact;
            this.dbContacts[contact.dbId] = contact;
            this.jtelContacts[contact.jidtel] = contact;
            this.logger.info("[contactService] GetContactByDBId (" + dbId + ") -- " + contactData.jid_im + " -- success");

            if (contactData.jid_im.indexOf("tv_") === 0) {
                //we just fetched a rainbow tv from the server, link the infos (if available)
                this.sendInnerEvent(ContactServiceInnerEvents.ON_RAINBOW_ROOM_CONTACT_CREATED, contact);
            }
            return contact;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactByDBId');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public async getContactByJid(jid: string, server: boolean = false): Promise<Contact | undefined> {
        try {
            this.logger.info(`[ContactService] getContactByJid(${jid})`);

            // Search in cache
            if (this.isUserContactJid(jid)) return this.userContact;
            if (this.contacts[jid]) return this.contacts[jid];

            // Search server side
            if (server) {
                const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/jids/${jid}`;
                const response: Response = await fetch(url, { method: 'GET', headers: this.authService.getRequestHeader() });
                if (!response.ok) { throw (response); }
                const userData = (await response.json())?.data;
                if (!userData) return undefined;
                const contact = this.createContact();
                contact.updateFromUserData(userData);
                //if (!contact.isAnonymousGuest()) {
                this.contacts[contact.id] = contact;
                this.dbContacts[contact.dbId] = contact;
                this.jtelContacts[contact.jidtel] = contact;
                contact.temp = false;

                if (contact.jid.indexOf("tv_") === 0) {
                    //we just fetched a rainbow tv from the server, link the infos (if available)
                    this.sendInnerEvent(ContactServiceInnerEvents.ON_RAINBOW_ROOM_CONTACT_CREATED, contact);
                }
                //}
                return contact;
            }
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactByJid');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
        return undefined;
    }

    public async getContactsByJids(jids: string[]) {
        try {
            this.logger.info(`[ContactService] getContactsByJids with [${(jids.length > 10) ? jids.length : jids.join()}]`);
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/jids?limit=1000`;
            const response: Response = await fetch(url, { method: 'POST', headers: this.authService.getPostHeader(), body: JSON.stringify({ jid_im: jids }) });
            if (!response.ok) { throw (response); }
            const responseData = await response.json();
            responseData.data.forEach((userData: any) => {
                let contact = this.getContactFromCacheByJid(userData.jid_im);
                if (!contact) { contact = this.createContact(); }
                contact.updateFromUserData(userData);
                //if (!contact.isAnonymousGuest()) {
                this.contacts[contact.id] = contact;
                this.dbContacts[contact.dbId] = contact;
                this.jtelContacts[contact.jidtel] = contact;
                contact.temp = false;
                //}
            });
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactsByJids');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Get a contact by his email
     * @param email - the email of the contact to be found
     */
    public getContactFromCacheByEmail(email: string): Contact {
        const contactKey = Object.keys(this.contacts).find((key) => { return this.contacts[key].containsEmail(email); });
        return contactKey ? this.contacts[contactKey] : null;
    }

    public async getContactByEmail(email: string, server: boolean = false): Promise<Contact | undefined> {
        try {
            this.logger.info(`[ContactService] getContactByEmail(${email})`);

            // Search in cache
            let contact: Contact = this.getContactFromCacheByEmail(email);
            if (!contact && server) {
                const contacts = await this.getContactsByEmails([email]);
                if (contacts?.contactsArray?.length === 1) contact = contacts?.contactsArray[0];
            }
            return contact;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactByEmail');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public async getContactsByEmails(emails: string[]): Promise<UsersByEmailsResult> {
        try {
            this.logger.info("[ContactService] getContactsByEmails with [" + emails.join() + "]");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/loginemails`;
            const loginEmail = emails.map((email: string) => { return email.toLowerCase(); });
            const response: Response = await fetch(url, { method: 'POST', headers: this.authService.getPostHeader(), body: JSON.stringify({ loginEmail }) });
            if (!response.ok) { throw (response); }
            const responseData = await response.json();
            const contacts = {};
            const contactsArray = responseData.data.map((userData: any) => {
                let contact = this.dbContacts[userData.id];
                if (!contact) {
                    contact = this.createContact();
                    this.contacts[contact.id] = contact;
                    this.dbContacts[contact.dbId] = contact;
                    this.jtelContacts[contact.jidtel] = contact;
                }
                contact.updateFromUserData(userData);
                contacts[contact.loginEmail] = contact;
                loginEmail.splice(loginEmail.indexOf(contact.loginEmail.toLowerCase()), 1);
                return contact;
            });
            return { contacts: contacts, contactsArray: contactsArray, emails: loginEmail };
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactsByEmails');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public async getContactInfoByEmail(email: string): Promise<any> {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/loginemails?format=full`;
            const response: Response = await fetch(url, { method: 'POST', headers: this.authService.getRequestHeader(), body: JSON.stringify({ loginEmail: [email] }) });
            if (!response.ok) { throw (response); }
            const responseData = await response.json();
            return responseData.data;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getContactInfoByEmail');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Get a contact by his phonenumber
     * @param phonenumber - the phonenumber of the contact to be found
     */
    public getContactFromCacheByPhoneNumber(phonenumber: string): Contact {
        const contact = this.contacts[phonenumber];
        return contact ? contact : null;
    }

    /**
     * Get a contact which contains a phoneNumber from cache
     * @param phonenumber - the phonenumber of the contact to be found
     */
    public getContactFromCacheContainsPhoneNumber(phonenumber: string): Contact {
        const contactKey = Object.keys(this.contacts).find((key) => { return this.contacts[key].containsPhoneNumber(phonenumber); });
        return contactKey ? this.contacts[contactKey] : null;
    }

    /**
     * Get a directory contact by his phonenumber
     * @param phonenumber - the phonenumber of the contact to be found
     */
    public getDirectoryContactByPhoneNumber(phonenumber: string): Contact {
        const contactKey = Object.keys(this.contacts).find((key) => { return this.contacts[key].containsDirectoryPhoneNumber(phonenumber); });
        return contactKey ? this.contacts[contactKey] : null;
    }

    /**
     * Get contact by jid or by his phone number; If not found, contact will created and updated from server if possible
     * @param jid - the jid of the contact to be found
     * @param phoneNumber - if user has no jid, it could be found by his phone number
     */
    public getOrCreateContact(jid: string, phoneNumber: string = null): Promise<Contact> {

        // Try to find an existing contact (Bot contacts should be found here as they do not have a valid JID)
        if (!jid && !phoneNumber) { return Promise.reject(new Error('No jid or no phoneNumber')); }
        const existingContact = jid ? this.getContactFromCacheByJid(jid) : this.getContactFromCacheByPhoneNumber(phoneNumber);
        if (existingContact) { return Promise.resolve(existingContact); }

        // Otherwise compute contactId
        if (jid && jid.indexOf("@") === -1) { return Promise.reject(new Error("Invalid jid " + jid)); }
        const contactId = jid ? jid : phoneNumber;

        // If phoneNumber only contact
        if (!jid) { return Promise.resolve(this.createBasicContact(null, phoneNumber)); }

        // Create promise if not pending
        if (!this.getContactPromises[contactId]) {
            this.getContactPromises[contactId] = new Promise((resolve, reject) => {

                // Create and store contact in contact hashmaps
                const contact = this.createBasicContact(jid, phoneNumber, false);

                this.updateContactFromServer(contact)
                    .then(() => {
                        this.contacts[contact.id] = contact;
                        this.dbContacts[contact.dbId] = contact;
                        this.jtelContacts[contact.jidtel] = contact;
                        delete this.getContactPromises[contactId];

                        resolve(contact);
                    })
                    .catch((error) => {
                        this.logger.error("[contactService] getOrCreateContact -- failure -- " + error.message);
                        delete this.getContactPromises[contactId];
                        reject(error);
                    });
            });
        }
        return this.getContactPromises[contactId];
    }

    // ----------------------------------------------------
    //      CREATE contact STUFF
    // => All possible ways to create a contact
    // ----------------------------------------------------

    private createConnectedUser(): ConnectedUserRB {
        const userContact = new ConnectedUserRB();
        userContact.avatarServerURL = config.webservices.protocol + "://" + config.webservices.currentServer;
        userContact.displayOrder = this.getDisplayOrder();
        return userContact;
    }

    public createContact(): Contact {
        const contact = new Contact();
        contact.avatarServerURL = config.webservices.protocol + "://" + config.webservices.currentServer;
        contact.firstname = null;
        contact.lastname = null;
        contact.displayOrder = this.getDisplayOrder();
        contact.computeDisplayName();
        return contact;
    }

    public createBotContact(jid: string, name: string, id: string, botAvatarUrl: string, botCapabilities: any, isRainbowSupportBot: boolean): Contact {
        let contact = this.contacts[jid];
        if (!contact) {
            contact = new Contact(jid);

            if (isRainbowSupportBot) {
                contact.botDetails = "emilyDetails";
            }
        }
        contact.displayOrder = this.getDisplayOrder();
        contact.lastname = name;
        contact.isBot = true;
        contact.status = "online";
        contact.imStatus = "online";
        contact.subscription = "both";
        contact.computeDisplayName();
        contact.avatar = (window as any).rainbowSDK ? null : { src: botAvatarUrl };
        contact.dbId = id;
        contact.isBotSharing = botCapabilities ? botCapabilities.some(function (param) { return param === "SHARING"; }) : false;

        this.contacts[contact.id] = this.dbContacts[id] = contact;
        return contact;
    }

    public createBasicContact(jid: string, phoneNumber: string = null, append: boolean = true) {
        this.logger.debug(`[ContactService] CreateContact ${jid} ${anonymizer(phoneNumber)}`);

        // Create the contact object
        const contact = this.createContact();

        // Handle case where we have no jid
        if (!jid) {
            contact.id = phoneNumber;
            contact.initials = "?";
            contact.displayName = phoneNumber ? phoneNumber : (this.i18nService.isInitialized ? this.i18nService.translate("accountDeleted") : "Unknown contact");
            contact.lastname = phoneNumber ? phoneNumber : (this.i18nService.isInitialized ? this.i18nService.translate("accountDeleted") : "Unknown contact");
            contact.firstname = "";
            contact.phoneProCan = phoneNumber ? phoneNumber : "";
            contact.phonePro = contact.phoneProCan;
            contact.temp = true;
            if (config.sdk) {
                contact.avatar = { src: "" };
            } else {
                contact.avatar = { src: "/assets/skins/rainbow/images/conversations/unknownUser.jpeg" };
            }
            contact.nameUpdatePrio = Contact.NameUpdatePrio.NO_UPDATE_PRIO;//not yet updated
            return contact;
        }

        // Compute the contact id
        let contactId = jid;
        if (!contactId) { contactId = phoneNumber; contact.phoneProCan = phoneNumber; }
        if (!contactId) { contactId = "anonymous"; }

        // Configure contact
        contact.jid = jid;
        contact.id = contactId;
        contact.ask = "none";
        contact.subscription = "none";
        this.updateContactRichStatus(contact);

        // Append in contact list
        if (append) { this.contacts[contact.id] = contact; }

        return contact;
    }

    public createEmptyContact(jid: string): Contact {
        const contact = this.createBasicContact(jid);
        contact.initials = "?";
        contact.displayName = this.i18nService.isInitialized ? this.i18nService.translate("accountDeleted") : "Unknown contact";
        contact.lastname = this.i18nService.isInitialized ? this.i18nService.translate("accountDeleted") : "Unknown contact";
        contact.firstname = "";
        contact.temp = true;
        contact.avatar = { src: "/assets/skins/rainbow/images/conversations/unknownUser.jpeg" };
        return contact;
    }

    /**
    * Create a new directory contact instance (as Contact model).
    * Used for contact from Business directory / Personal directory / Microsoft Azure Active directory
    * Usually only Personal directory contacts are stored in the 'contacts' database.
    * @param id - The id of the new created directory contact
    * @param storeDb - Flag indicating whether the contact should be stored in the 'contacts' id-key database
    */
    public createDirectoryContact(id: string, storeDb: boolean = true): Contact {
        this.logger.debug(`[ContactService] createDirectoryContact ${id} `);

        // Create the contact object
        const contact = this.createContact();

        // Configure contact
        contact.id = id;
        contact.jid = id;
        contact.dbId = id;
        contact.ask = "none";
        contact.subscription = "none";
        this.updateContactRichStatus(contact);

        // Store this contact in contact maps
        if (storeDb) {
            this.contacts[contact.id] = contact;
            // NOT stored in this.dbContacts ... not useful for the moment (I hope)
        }

        return contact;
    }

    public createCallLogContact(phoneNumber: string): Contact {
        // Create the contact object
        const contact = this.createContact();

        // PMA: TO DO ONE DAY... Enhancement: Add prefix to the id to mark it as reserved for Call Log
        // But lot of impacts in Call Log service (Ex: deletion in condensed mode, pers dir name resolution...) => prefix must be removed !
        // Set unique id built on "callLog-" prefix + provided phoneNumber
        // contact.id = "callLog-" + phoneNumber;
        contact.id = phoneNumber;

        // Store phonenumber
        contact.initials = "?";
        contact.displayName = phoneNumber;
        contact.lastname = phoneNumber;
        contact.firstname = "";
        contact.phoneProCan = phoneNumber;
        contact.phonePro = phoneNumber;
        contact.temp = true;
        if (config.sdk) {
            contact.avatar = { src: "" };
        } else {
            contact.avatar = { src: "/assets/skins/rainbow/images/conversations/unknownUser.jpeg" };
        }
        contact.nameUpdatePrio = Contact.NameUpdatePrio.NO_UPDATE_PRIO;//not yet updated

        // local debug only:  this.logger.debug(`[ContactService] createCallLogContact ${contact.id} -- phoneNumber ${phoneNumber}`);
        this.logger.debug(`[ContactService] createCallLogContact ${anonymizer(contact.id)} -- phoneNumber ${anonymizer(phoneNumber)}`);

        // Call logs contact are NOT stored in contact maps (this.contacts and this.dbContacts)
        return contact;
    }

    public createContactFromData(userData: any): Contact {
        // Try to find an existing contact
        if (!userData) { return null; }

        const existingContact = this.getContactFromCacheByJid(userData.jid_im);
        if (existingContact) {
            // Add (if necessary) routines properties
            // Routines
            if (!existingContact.personalRoutines && userData.personalRoutines) {
                existingContact.personalRoutines = userData.personalRoutines.map((userDataRoutine: any) => {
                    return PersonalRoutine.createRoutineFromData(userDataRoutine);
                });
            }

            // Add (if necessary) outOfOffice properties
            if (!existingContact.outOfOffice && userData.outOfOffice) {
                existingContact.outOfOffice = userData.outOfOffice;
            }

            // Add (if necessary) forward properties
            // Forwards (Voice Hub system)
            if (!existingContact.forwards && userData.forwards) {
                existingContact.forwards = userData.forwards.map((userDataForward: any) => {
                    return TelephonyForward.createForwardFromVoiceUserData(userDataForward);
                });
            }
            // Forward (Hybrid system)
            if (!existingContact.forwards && userData.forward) {
                existingContact.forwards = [TelephonyForward.createForwardFromHybridData(userData.forward)];
            }
            return existingContact;
        }

        // Create and store contact in contact hashmaps
        const contact = this.createBasicContact(userData.jid_im, undefined, false);

        contact.updateFromUserData(userData);
        this.updateContactRichStatus(contact, this.isUserContactJid(contact.jid));
        this.sendContactUpdateEvent(contact, "create");

        this.contacts[contact.id] = contact;
        this.dbContacts[contact.dbId] = contact;
        this.jtelContacts[contact.jidtel] = contact;

        return contact;
    }

    // ------------------------------------------------------------------------
    //      LOCAL UPDATE contact STUFF
    // Update of some global properties of the contact instance from server data
    // received through  API or XMPP.
    // BUT NOT the update of the contact on server side !
    // ------------------------------------------------------------------------

    public async updateContactFromServer(contact: Contact) {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/jids/${contact.jid}?format=full`;
            const response: Response = await fetch(url, { headers: this.authService.getRequestHeader() });
            if (!response.ok) { throw (response); }
            const responseData = await response.json();
            contact.updateFromUserData(responseData.data);
            this.updateContactRichStatus(contact, this.isUserContactJid(contact.jid));
            this.sendContactUpdateEvent(contact, "update");
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'updateContactFromServer');
            this.logger.info(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public updateContactPersonalRoutines(contactJidIm: string, personalRoutineData: any): void {
        if (!contactJidIm) return;

        const existingContact = this.getContactFromCacheByJid(contactJidIm);
        if (existingContact) {
            existingContact.personalRoutines = personalRoutineData.map((userDataRoutine: any) => {
                return PersonalRoutine.createRoutineFromData(userDataRoutine);
            });
        }
        return;
    }

    // ------------------------------------------------------------------------
    //      SERVER UPDATE contact STUFF
    // Update of some global properties of the contact instance
    // from server data (API or XMPP)
    // BUT NOT the update of the contact on server side !
    // ------------------------------------------------------------------------

    /**
     * Update the user's profile data (name, emails, numbers, etc)
     * Returns the updated user if success and an update on the contact RX is received (or undefined, if the user is not allowed to update his profile)
     * @param userProfile - The userData to be sent to the server for update
     * @param checkProfile - when true check if userModification is allowed for this user
     */
    public async updateUserProfile(userProfile: ConnectedUserProfile & ConnectedUserInit & ConnectedUserMedia, checkProfile: boolean = false): Promise<User> {
        try {
            let responseData = null;

            if (checkProfile && this.userContact && !this.userContact.modifyProfileEnabled) {
                this.logger.warn("[contactService] updateUserContactProfileData is not allowed for this contact");
                return undefined;
            }

            this.logger.info("[contactService] updateUserContact");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.authService.userId}`;
            const headers = this.authService.getPostHeader();
            const response: Response = await fetch(url, { method: 'PUT', headers, body: JSON.stringify(userProfile) });
            if (!response.ok) throw (response);
            responseData = (await response.json()).data;
            this.userContact.updateFromUserData(responseData);
            this.authService.loggedInUser = responseData;
            this.logger.info("[contactService] updateUserContact successfully");
            return this.userContact;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'updateUserContact');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Update the user's custom data (emergencyImSound, enablePushToTalkTone, guideTourDisplayed, etc...)
     * Returns the updated contact if success and an update on the contact RX is received (or undefined, if the user is not allowed to update his profile)
     * @param UserCustomData - customData to be sent to the server for update
     */
    public async updateUserCustomData(customData: UserCustomData): Promise<Contact> {
        try {
            let responseData = null;

            this.logger.info("[contactService] updateUserCustomData");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.authService.userId}`;
            const headers = this.authService.getPostHeader();
            const response: Response = await fetch(url, { method: 'PUT', headers, body: JSON.stringify({ customData: customData }) });
            if (!response.ok) throw (response);
            responseData = (await response.json()).data;
            this.userContact.updateFromUserData(responseData);
            this.authService.loggedInUser = responseData;
            this.logger.info("[contactService] updateUserCustomData successfully");
            return this.userContact;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'updateUserCustomData');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Update the user's custom status
     * @param status - status of type {@link UserCustomStatus} to be sent to the server for update
     */
    public async updateUserCustomStatus(status: UserCustomStatus): Promise<void> {
        try {
            let responseData = null;

            this.logger.info("[contactService] updateUserCustomStatus");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.authService.userId}/custom-status`;
            const headers = this.authService.getPostHeader();

            const response: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(status) });
            if (!response.ok) throw (response);
            responseData = (await response.json()).data;
            this.userContact.updateCustomStatus(responseData);
            this.logger.info("[contactService] updateUserCustomStatus successfully");

        } catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'updateUserCustomStatus');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Delete the user's custom status
     */
    public async deleteUserCustomStatus(): Promise<void> {
        try {
            this.logger.info("[contactService] deleteUserCustomStatus");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.authService.userId}/custom-status`;
            const headers = this.authService.getPostHeader();
            const response: Response = await fetch(url, { method: 'DELETE', headers });
            if (!response.ok) throw (response);
            this.userContact.updateCustomStatus(null);
            this.logger.info("[contactService] deleteUserCustomStatus successfully");

        } catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'deleteUserCustomStatus');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    // ----------------------------------
    //      DELETE contacts STUFF
    // ----------------------------------

    /**
     * Delete the account of the connected user.
     * his API will delete the current user from the server ! BE CAREFUL !
     */
    public async deleteConnectedUserAccount(): Promise<void> {
        try {
            this.logger.info("[contactService] deleteConnectedUserAccount");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.userContact.dbId}`;
            const response: Response = await fetch(url, { method: 'DELETE', headers: this.authService.getRequestHeader() });
            if (!response.ok) throw (response);
            await response.json();
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'deleteConnectedUserAccount');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
    * Remove a directory contact instance from the 'contacts' cache database.
    * Warning: The reference must be deleted by the caller, nothing done here !
    * Mainly used for personal directory contact management.
    * @param deletedContact - The directory contact to remove from cache.
    */
    public removeDirectoryContactFromCache(deletedContact: Contact): void {
        this.logger.debug(`[ContactService] removeDirectoryContactFromCache ${deletedContact} ${deletedContact?.id}`);

        if (deletedContact) {
            // Delete 'contacts' database entry
            delete this.contacts[deletedContact.id];

            // Warning!
            // Reassigning 'deletedContact' to undefined will not affect the original variable on caller side.
            // If we wanted to do this, we'd have to pass the deletedContact into a structure (a container)
        }
    }

    // ----------------------------------------------------
    // GET specific contact(s) or retrieve a list of contacts
    // that belong to a particular category.
    // ----------------------------------------------------

    /**
     * Get the contact associated to the connected user.
     */
    public getConnectedUser(): User { return this.userContact; }

    private async refreshUserNetwork() {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/networks?limit=2000&format=full`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'GET', headers });
            if (!response.ok) throw (response);
            const responseData = await response.json();
            this.logger.info(`[ContactService] refreshUserNetwork success -- find ${responseData.data.length} contact(s); Update current roster`);
            responseData.data.forEach((contactData: any) => {
                //find contact from cache
                if (this.dbContacts[contactData.id]) {
                    this.dbContacts[contactData.id].updateFromUserData(contactData);
                    if (contactData.showPresence) { this.dbContacts[contactData.id].subscription = "both"; }
                    if (!this.dbContacts[contactData.id].roster) {
                        this.dbContacts[contactData.id].roster = true;
                        this.updateContactRichStatus(this.dbContacts[contactData.id], false);
                    }
                }
                else {
                    //manage newly added contacts ...
                    const contact: Contact = this.createContact();
                    contact.updateFromUserData(contactData);
                    if (contactData.showPresence) {
                        contact.subscription = "both";
                    }
                    contact.roster = true;
                    this.contacts[contact.id] = contact;
                    this.dbContacts[contact.dbId] = contact;
                    this.jtelContacts[contact.jidtel] = contact;

                    this.updateContactRichStatus(contact, false);
                }
            });
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'refreshUserNetwork');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    private async getNetwork() {
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/networks?limit=2000&format=full`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'GET', headers });
            if (!response.ok) throw (response);
            const responseData = await response.json();
            this.logger.info(`[ContactService] GetNetwork success -- find ${responseData.data.length} contact(s)`);
            responseData.data.forEach((contactData: any) => {
                const contact: Contact = this.createContact();
                contact.updateFromUserData(contactData);
                if (contactData.showPresence) {
                    contact.subscription = "both";
                }
                contact.status = "offline";
                contact.roster = true;
                this.contacts[contact.id] = contact;
                this.dbContacts[contact.dbId] = contact;
                this.jtelContacts[contact.jidtel] = contact;
            });
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getNetwork');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Returns the list of personal directory contacts defined by the connected user.
     * The 'PERSONAL_DIRECTORY' feature must be available.
     */
    public getPersonnalDirectoryContacts(): Contact[] {
        const contacts = this.getContacts().filter((contact) => {
            return (contact.personalDirectoryFlag);
        });
        return contacts;
    }

    // ----------------------------------------------------
    //      CONTACT SEARCH STUFF
    // => All possible ways to search contacts
    // ----------------------------------------------------

    public searchContacts(criteria: string) {
        const contacts = this.getContacts();
        return contacts.filter((contact) => {
            return ((contact.roster || contact.isBot) && !contact.isTerminated && this.contactMatcher(contact, criteria));
        });
    }

    /**
     * Search users in the Rainbow users network (ie 'My Network') of the connected user by using a specified pattern to filter items.
     * Resolves with an array of contacts and the total number of users matching the criteria.
     * @param searchPattern - Pattern to search
     * @param options - Search options
     */
    public searchRainbowUsersNetwork(searchPattern: string, options?: DirectorySearchOptions): DirectoryInternalSearchResults {
        let contacts: Contact[] = this.getContacts();
        contacts = contacts.filter((contact) => {
            return ((contact.roster || contact.isBot) && !contact.isTerminated && this.contactMatcher(contact, searchPattern));
        });
        const nbFoundContacts: number = contacts.length;

        if (options?.limit) {
            contacts = contacts.slice(0, options?.limit);
        }

        return { contacts: contacts, total: nbFoundContacts };
    }

    // ----------------------------------
    //      PRESENCE   STUFF
    // ----------------------------------

    private setUserContactStatus(status: string, message: string = null, withAuthInfo: boolean = false, userOptions?: { im: boolean; alert: boolean; companyid: string; ringingOnDnd: boolean; rejectOnBusy: boolean; }): void {
        try {
            this.logger.info("[ContactService] Set userContact status : " + status + (message ? "(" + message + ")" : ""));

            if (this.xmppService.started) {
                if (status === "online") {
                    this.manualState = false;
                    this.dndStateActivated = false;
                    this.xmppService.sendPresence(null, message, withAuthInfo, userOptions);
                }
                else {
                    this.manualState = true;
                    this.dndStateActivated = false;
                    if (status === "away") { this.xmppService.sendPresence("away", message, withAuthInfo, userOptions); }
                    else if (status === "dnd") { this.dndStateActivated = true; this.xmppService.sendPresence("dnd", message, withAuthInfo, userOptions); }
                    else if (status === "xa") { this.xmppService.sendPresence("xa", message, withAuthInfo, userOptions); }
                }
            }
        }
        catch (error) {
            this.logger.error("[ContactService] Set userContact status error : " + error);
        }
    }

    private calculateContactStatusFromResources(contact: Contact, isMe: boolean) {
        let onThePhone = false;
        let manualInvisible = false;
        let manualDnd = false;
        let manualAway = false;
        let calendarDND = false;
        let presentationMode = false;
        let busyWebrtc = false;
        let busyWebrtcStatus = "";
        let online = false;
        let onlineMobile = false;
        let autoAway = false;
        let msTeamsBusy = false;
        let msTeamsDND = false;
        let externalPresence = false;
        const externalPresenceStatus = { presence: '', message: '' };
        let fullJid: string = contact.fullJid;

        let presence = "offline";
        let status = "";

        if (contact.calendarState.applyCalendarPresence && (contact.calendarState.message === "busy" || contact.calendarState.message === "out_of_office")) {
            calendarDND = true;
        }

        if (contact.msTeamsPresence) {
            msTeamsBusy = (contact.msTeamsPresence === "busy");
            msTeamsDND = (contact.msTeamsPresence === "dnd");
        }

        Object.keys(contact.resources).forEach((key: string) => {
            const resource = contact.resources[key];
            if (resource.type !== "phone") {

                if (!isMe && !fullJid) { fullJid = key; }

                if (resource.show === "xa" && resource.status === "") {
                    manualInvisible = true;
                }
                else if (resource.show === "dnd" && resource.status === "") {
                    manualDnd = true;
                }
                else if (resource.show === "xa" && resource.status === "away") {
                    manualAway = true;
                }
                else if (resource.show === "dnd" && resource.status === "presentation") {
                    presentationMode = true;
                }
                else if (resource.show === "dnd" && (resource.status === "audio" || resource.status === "video" || resource.status === "sharing")) {
                    busyWebrtc = true;
                    busyWebrtcStatus = resource.status;
                }
                //custom status external
                else if ((resource.show === "xa" && resource.status !== "") || (resource.show === "dnd" && resource.status !== "")
                        || (resource.show === "away" && resource.status !== "") || ((resource.show === "" || resource.show === "online") && !(resource.status === "" || resource.status === "mode=auto"))) {
                    externalPresence = true;
                    externalPresenceStatus.presence = resource.show;
                    externalPresenceStatus.message = resource.status;
                }
                else if ((resource.show === "" || resource.show === "online") && (resource.status === "" || resource.status === "mode=auto")) {
                    if (key.indexOf("mobile_") !== -1) {
                        onlineMobile = true;
                    }
                    else {
                        online = true;
                    }
                }
                else if (resource.show === "away" && resource.status === "") {
                    autoAway = true;
                }
            }
            else {
                if (resource.status === "EVT_SERVICE_INITIATED" || resource.status === "EVT_ESTABLISHED") {
                    onThePhone = true;
                }
                else {
                    onThePhone = false;
                }
            }
        });

        if (onThePhone) {
            presence = "busy";
            status = "phone";
        } else if (manualInvisible) {
            presence = "xa";
            status = "";
            if (isMe) { this.dndStateActivated = false; }
        } else if (manualDnd) {
            presence = "dnd";
            status = "";
            if (isMe) { this.dndStateActivated = true; }
        } else if (manualAway) {
            presence = "away";
            status = "";
            if (isMe) { this.dndStateActivated = false; }
        } else if (calendarDND) {
            presence = "dnd";
            status = "appointment";
            if (isMe) { this.dndStateActivated = true; }
        } else if (presentationMode) {
            presence = "dnd";
            status = "presentation";
            if (isMe) { this.dndStateActivated = true; }
        } else if (busyWebrtc) {
            presence = "busy";
            status = busyWebrtcStatus;
            if (isMe) { this.dndStateActivated = false; }
        } else if (msTeamsBusy) {
            presence = "dnd";
            status = "Teams";
            if (isMe) { this.dndStateActivated = true; }
        } else if (msTeamsDND) {
            presence = "dnd";
            status = "Teams";
            if (isMe) { this.dndStateActivated = true; }
        } else if (externalPresence) {
            //check for external busy
            if (externalPresenceStatus.presence === "dnd" && externalPresenceStatus.message === "busy") {
                presence = 'busy';
                status = '';
            }
            else {
                presence = externalPresenceStatus.presence;
                status = externalPresenceStatus.message;
            }
        } else if (online) {
            presence = "online";
            status = "";
            if (isMe) { this.dndStateActivated = false; }
        } else if (onlineMobile) {
            presence = "online-mobile";
            status = "";
            if (isMe) { this.dndStateActivated = false; }
        } else if (autoAway) {
            presence = "away";
            status = "";
            if (isMe) { this.dndStateActivated = false; }
        }

        if (!isMe && !contact.fullJid) { contact.fullJid = fullJid; }

        return { presence: presence, message: status };
    }

    private updatePresence(forced: boolean = false): void {
        this.logger.info("[ContactService] updatePresence");
        if (this.manualState) {
            this.logger.info("[ContactService] updatePresence manualState");
            if (this.userContact.status === "away" && this.busyState && this.busyState.status === "dnd") {
                this.setUserContactStatus("online", "mode=auto");
                this.setUserSettings({ presence: "online" });
                //update also the settings
                setTimeout(() => { this.updatePresence(); }, 1000);
            }
        }
        else if (this.presentationModeActive && (!this.busyState?.status)) {
            this.logger.info("[ContactService] updatePresence dnd presentation");
            this.xmppService.sendPresence("dnd", "presentation");
        }
        else if (this.busyState && this.busyState.status === "dnd") {
            this.logger.info("[ContactService] updatePresence dnd " + this.busyState.message);
            this.xmppService.sendPresence("dnd", this.busyState.message);
        }
        else if (this.awayStateActive) {
            this.logger.info("[ContactService] updatePresence away");
            this.xmppService.sendPresence("away", "");
        }
        else if (this.userContact && this.userContact.status !== "online") {
            this.logger.info("[ContactService] updatePresence online");
            this.setUserContactStatus("online");
        }
        else if (forced && this.userContact && this.userContact.status === "online") {
            this.logger.info("[ContactService] updatePresence forced online");
            this.setUserContactStatus("online");
        }
    }

    private updateContactTelephonyStatus(contact: Contact, attr: any, isMe: boolean) {
        const statusOrg = contact.telStatus;
        if (this.getResourceFromJid(attr.jid) === "pcg2") { // pcg2 sipWise presence
            switch (attr.status) {
                case "offline": contact.telStatus = ''; break;
                case "online": contact.telStatus = "EVT_CONNECTION_CLEARED"; break;
                case "dnd": contact.telStatus = "EVT_ESTABLISHED"; break;
                default: contact.telStatus = ''; break;
            }
        }
        else { //Normal PCG1 phone presence (not sipWise)
            contact.telStatus = attr.message;
        }
        this.updateContactRichStatus(contact, isMe);
        if (isMe && (statusOrg !== contact.telStatus)) { this.eventService.publish("ON_UPDATE_MYTELEPHONY_STATUS_EVENT"); }
    }

    private updateContactIMStatus(contact: Contact, attr: any, isMe: boolean) {

        // Check stamp validity and ignore obsolete messages
        if (contact.imStatusStamp[attr.jid] && contact.imStatusStamp[attr.jid] > attr.stamp) {
            this.logger.info("[ContactService] Ignore obsolete presence message for contact " + contact.jid);
            return;
        }
        if (!this.getResourceFromJid(attr.jid)) {
            //no ressource related to the presence, ignore it;
            this.logger.info("[ContactService] Ignore no ressource presence message for contact " + contact.jid);
            return;
        }

        this.logger.info("[ContactService] updateIMStatus " + JSON.stringify(attr));
        contact.imStatusStamp[attr.jid] = attr.stamp;

        if (attr.status) { contact.imStatus = attr.status; }

        const status = attr.message ? attr.message : "";

        if (contact.imStatus === "offline") {
            if (!isMe && contact.fullJid === attr.jid) { contact.fullJid = null; }
            delete contact.resources[attr.jid];
            delete contact.imStatusStamp[attr.jid];
            if (contact.resources.length === 0) { contact.message = ""; }

            //in case of offline ressource for our user, send event for update of list of my ressources
            if (isMe) {
                this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_JID_RESOURCE_CHANGE, { fullJid: attr.jid, action: "remove" });
            }
        }
        else {
            if (contact.resources[attr.jid]) {
                contact.resources[attr.jid].show = contact.imStatus;
                contact.resources[attr.jid].status = status;
                contact.resources[attr.jid].stamp = attr.stamp;
            }
            else {
                contact.resources[attr.jid] = { show: contact.imStatus, status: status, initStamp: attr.stamp, stamp: attr.stamp };

                //in case of new ressource for our user, send event for update of list of my ressources
                if (isMe) {
                    this.sendInnerEvent(ContactServiceInnerEvents.ON_CONNECTED_USER_JID_RESOURCE_CHANGE, { fullJid: attr.jid, action: "added" });
                }
            }

            this.logger.info("[Contact] updateIMStatus user resources after update " + JSON.stringify(contact.resources));

            // Store fullJid only if from web client (not concerning me)
            if (!this.xmppService.isMobileResource(attr.jid) && !isMe) {
                contact.fullJid = attr.jid;
            }

            // Allow mobiles if flag is activated
            if (!isMe && config.webrtcWithMobiles) { contact.fullJid = attr.jid; }
        }

        this.updateContactRichStatus(contact, isMe);

        if (isMe && this.xmppService.isMobileResource(attr.jid)) {
            if (attr.status !== "offline" && contact.mobileResource === null) {
                contact.mobileResource = attr.jid;
                this.logger.info("[Contact] updateIMStatus: post event ON_MOBILE_TELEPHONY_STATUS_CHANGE");
                this.sendInnerEvent(ContactServiceInnerEvents.ON_MOBILE_TELEPHONY_STATUS_CHANGE, "started");
            }

            if (attr.status === "offline") {
                let otherMobileResource = null;

                for (const key in contact.resources) {
                    if (contact.resources.hasOwnProperty(key)) {
                        if (this.xmppService.isMobileResource(key)) {
                            otherMobileResource = key;
                            break;
                        }
                    }
                }
                contact.mobileResource = otherMobileResource;

                if (contact.mobileResource === null) {
                    this.sendInnerEvent(ContactServiceInnerEvents.ON_MOBILE_TELEPHONY_STATUS_CHANGE, "stopped");
                }
            }
        }
    }

    private getMissedPresenceMessages() {
        this.logger.info("[ContactService] GetMissedPresenceMessages");
        try {
            const list = this.xmppService.getPresenceWaitingList();
            if (list.length) {
                this.logger.info("[ContactService] GetMissedPresenceMessages length " + list.length);
                while (list.length > 0) {
                    const item = list.pop();
                    this.contactPresenceChangedHandler(item);
                }
                this.xmppService.resetPresenceWaitingList();
            }
        }
        catch (error) {
            this.logger.error("[ContactService] GetMissedPresenceMessages error " + error);
        }
    }

    private manageUserSettingsPresenceChange(presence: string) {
        let message = "";
        if (presence === "invisible") { presence = "xa"; }
        else if (presence === "away") { presence = "xa"; message = "away"; }

        this.logger.info("[ContactService] manageUserSettingsPresenceChange with new " + presence + " and message : " + message);
        if (this.userContact?.resources?.[this.userContact.fullJid]) {
            const myRessource = this.userContact.resources[this.userContact.fullJid];
            if (myRessource && (myRessource.show !== presence || (myRessource.show === "dnd" && myRessource.status !== "") || (myRessource.show === "xa" && myRessource.status !== message))) {

                // Ignore the update of the presence if already in call and not in Manual mode
                if (!this.busyState || this.busyState.status !== "dnd" || this.manualState) {
                    this.logger.info("[ContactService] manageUserSettingsPresenceChange should update my status from " + myRessource.show + " to " + presence + " (" + message + ")");
                    const userOptions = {
                        im: this.userContact.instantMessagesEnabled,
                        alert: this.userContact.alertNotificationEnabledForMyCompany,
                        companyid: this.userContact.company ? this.userContact.company.id : "",
                        ringingOnDnd: this.settingsService.getSetting("ringingOnDnd") === "true",
                        rejectOnBusy: this.settingsService.getSetting("rejectOnBusy") === "true"
                    };
                    if (presence === "dnd") { this.dndStateActivated = true; }
                    else { this.dndStateActivated = false; }

                    this.setUserContactStatus(presence, message, false, userOptions);

                    //if user is in call and we leave the manual state, update the presence to the call
                    if (this.busyState?.status === "dnd" && !this.manualState && !this.dndStateActivated) {
                        setTimeout(() => { this.updatePresence(); }, 500);
                    }
                }
            }
        }
    }

    public updateContactRichStatus(contact: Contact, isMe: boolean = false) {
        let changed = false;
        if (contact.telStatus === 'EVT_SERVICE_INITIATED' || contact.telStatus === 'EVT_ESTABLISHED') {
            if (contact.status !== 'busy' || contact.message !== 'audioPhone') { changed = true; }
            contact.status = 'busy';
            contact.message = 'audioPhone';
        }
        else {
            if (contact.ask === 'subscribe') {
                if (contact.status !== 'wait') { changed = true; }
                contact.status = 'wait';
            }
            else if (contact.subscription === 'none' || contact.subscription === 'from') {
                if (contact.status !== 'unknown') { changed = true; }
                contact.status = "unknown";
            }
            else {
                const calculatedStatus = this.calculateContactStatusFromResources(contact, isMe);

                // If user is not me and he is eXtended Away presence, show him as offline
                if (calculatedStatus.presence === "xa") {
                    if (calculatedStatus.message === "" && !isMe) { calculatedStatus.presence = "offline"; }
                    else if (calculatedStatus.message === "away") { calculatedStatus.presence = "away"; calculatedStatus.message = ""; }
                    else if (calculatedStatus.message && !isMe) { calculatedStatus.presence = "offline"; }
                }

                if (contact.status !== calculatedStatus.presence || contact.message !== calculatedStatus.message) { changed = true; }
                contact.status = calculatedStatus.presence;
                contact.message = calculatedStatus.message;
            }
        }

        this.logger.info(`[contactService] updateContactRichStatus ${isMe ? 'MY ' : 'USER'} PRESENCE : ${contact.status} || message : ${contact.message} -- changed: ${changed}`);

        if (changed) {
            //send inner event to update the capabilities for contact
            if (isMe) { this.sendInnerEvent(ContactServiceEvents.ON_CONNECTED_USER_PRESENCE_CHANGE, contact); }
            else {
                this.sendInnerEvent(ContactServiceEvents.ON_USER_PRESENCE_CHANGE, contact);
                contact.sendEvent(UserEvents.ON_PRESENCE_CHANGE);
            }

            this.sendContactUpdateEvent(contact, 'presence');
        }
    }

    public async sendPresenceFromConfiguration(sendAuthInfo: boolean = false) {
        this.logger.info("[ContactService] sendPresenceFromConfiguration " + (sendAuthInfo ? "(with auth info)" : ""));
        try {
            const setting = await this.getUserSettings();
            this.settingsService.setSetting('presence', setting.presence);
            let message = "";
            let presence = setting.presence;
            if (presence === "invisible") { presence = "xa"; }
            else if (presence === "away") { presence = "xa"; message = "away"; }

            this.logger.info("[ContactService] sendPresenceFromConfiguration -> getUserSettings are " + presence + " || message : " + message);
            if (this.userContact?.resources?.[this.userContact.fullJid]) {
                const myRessource = this.userContact.resources[this.userContact.fullJid];
                if (myRessource && (myRessource.show !== presence || (myRessource.show === "dnd" && myRessource.status !== "") || (myRessource.show === "xa" && myRessource.status !== message))) {

                    // Ignore the update of the presence if already in call and not in Manual mode
                    if (!this.busyState || this.busyState.status !== "dnd" || this.manualState) {
                        this.logger.info("[ContactService] sendPresenceFromConfiguration should update my status from " + myRessource.show + " to " + presence + " (" + message + ")");
                        const userOptions = {
                            im: this.userContact.instantMessagesEnabled,
                            alert: this.userContact.alertNotificationEnabledForMyCompany,
                            companyid: this.userContact.company ? this.userContact.company.id : "",
                            ringingOnDnd: this.settingsService.getSetting("ringingOnDnd") === "true",
                            rejectOnBusy: this.settingsService.getSetting("rejectOnBusy") === "true"
                        };
                        if (presence === "dnd") { this.dndStateActivated = true; }
                        else { this.dndStateActivated = false; }

                        this.setUserContactStatus(presence, message, sendAuthInfo, userOptions);

                        //if user is in call and we leave the manual state, update the presence to the call
                        if (this.busyState?.status === "dnd" && !this.manualState && !this.dndStateActivated) {
                            setTimeout(() => { this.updatePresence(); }, 500);
                        }
                    }
                }
            }
            else {
                const userOptions = {
                    im: this.userContact.instantMessagesEnabled === true,
                    alert: this.userContact.alertNotificationEnabledForMyCompany === true,
                    companyid: this.userContact.company ? this.userContact.company.id : "",
                    ringingOnDnd: this.settingsService.getSetting("ringingOnDnd") === "true",
                    rejectOnBusy: this.settingsService.getSetting("rejectOnBusy") === "true"
                };
                this.logger.info("[ContactService] sendPresenceFromConfiguration set initial presence ");
                if (presence === "dnd") { this.dndStateActivated = true; }
                else { this.dndStateActivated = false; }
                this.setUserContactStatus(presence, message, sendAuthInfo, userOptions);
            }
        }
        catch {
            this.logger.info("[ContactService] sendPresenceFromConfiguration failure, send online");
            this.setUserContactStatus("online", null, sendAuthInfo);
        }
    }

    /**
     * Return a list of available status that the user can use if he want to change his presence (via changeMyPresence API).
     * Possible values are ["online", "away", "xa", "dnd"]
     *    Online: User goes to online (or can "exit") any manual state; In case of a call in progress, the user will go to busy state;
     *    Away: Manual Away state
     *    xa: "invisble" or "appear offline" manual state
     *    dnd: Do not disturb manual state
     */
    public getConnectedUserAvailablePresenceStatusList(): string[] {
        let list: string[] = [];
        if (this.userContact?.status) {
            this.logger.info("[contactService] getConnecteUserAvailablePresenceStatusList " + this.userContact.status + " " + this.userContact.message);
            if (!this.userContact.changePresenceEnabled) { list = []; }
            else if (this.userContact.status === "offline") { list = ["online"]; }
            // else if (this.userContact.status === "dnd" && this.userContact.message === "presentation") { list = ["dnd"]; }
            else if (this.userContact.canSetInvisiblePresenceCustomisation) { list = ["online", "away", "xa", "dnd"]; }
            else { list = ["online", "away", "dnd"]; }
        }
        return list;
    }

    public async setConnectedUserCustomExternalPresence(presenceStatus: UserExternalPresenceStatus, customMessage: string = ''): Promise<void> {
        try {
            const url = `${config.restServerUrl}/api/rainbow/admin/v1.0/users/${this.userContact.dbId}/external-presence`;
            const headers = this.authService.getPostHeader();
            const body = { presence: presenceStatus, status: customMessage };
            if (presenceStatus === UserExternalPresenceStatus.BUSY) { delete body.status; }
            const response: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(body) });
            if (!response.ok) throw (response);
            this.logger.info(`[ContactService] setConnectedUserCustomExternalPresence ${presenceStatus} - ${customMessage} - success`);
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'setConnectedUserCustomExternalPresence');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public async removeConnectedUserCustomExternalPresence(): Promise<void> {
        try {
            const url = `${config.restServerUrl}/api/rainbow/admin/v1.0/users/${this.userContact.dbId}/external-presence`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'DELETE', headers });
            if (!response.ok) throw (response);
            this.logger.info(`[ContactService] removeConnectedUserCustomExternalPresence ${this.userContact.dbId} - success`);
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'removeConnectedUserCustomExternalPresence');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    /**
     * Change the current user presence status (if allowed); The status list can be get at all time via computeStatusList
     * @param status - The presence status that the user wants to set to his user. The status list can be get via computeStatusList API
     */
    public setConnectedUserPresence(presenceStatus: UserPresenceStatus | string): void {
        this.logger.info("[contactService] changeMyPresence " + presenceStatus + " " + this.userContact.message);
        let status: string = presenceStatus;
        let message = "";

        if ((status === "dnd" && this.userContact.message === "presentation") || status === "busy") { return; }

        if (status === "online") { message = "mode=auto"; }

        // If manual away
        if (status === "away") { status = "xa"; message = "away"; }

        // If user is in DND presentation mode, disable the presentation mode
        if (this.presentationModeActive) { this.presentationModeActive = false; }

        if (this.userContact.status === "busy" && (this.userContact.message === "phone" || this.userContact.message === "audioPhone") && (status === "xa" || status === "dnd" || status === "away")) {
            this.eventService.publish('GLOBAL_NOTIFY_MESSAGE_EVENT', "presenceActivatedConfirmation", true);
        }

        this.setUserContactStatus(status, message);

        if (status === "online") {
            setTimeout(() => { this.manualState = false; this.dndStateActivated = false; this.updatePresence(); }, 1000);
        }

        let presence = "online";
        if (status === "xa" && message === "away") { presence = "away"; }
        else if (status === "dnd") { presence = "dnd"; }
        else if (status === "xa") { presence = "invisible"; }
        this.setUserSettings({ presence: presence });
    }

    public resetBusyState() {
        this.logger.info("[ContactService] resetBusyState");
        this.setBusyState(null, null, true);
        // Send the stocked presence in the configuration
        this.sendPresenceFromConfiguration();
    }

    public setBusyState(status: string, message: string, noUpdate: boolean = false) {
        this.logger.info("[ContactService] setBusyState -- " + status + " -- " + message);
        this.busyState = { status: status, message: message };
        if (!noUpdate) { this.updatePresence(); }
    }

    // ----------------------------------
    //      PHONE NUMBERS & EMAIL  STUFF
    // ----------------------------------

    /**
     * Retrieve from the server all the phone numbers associated with a contact.
     * This is basically done for a USER contact and if these numbers have not already been retrieved.
     * @param contact - the contact
     */
    public async retrieveContactPhoneNumbers(contact: Contact): Promise<Contact> {
        if (contact.isBot) { throw new Error("No phone numbers for bot contacts"); }
        if (contact.phoneNumbersInitialized) { return contact; }
        if (contact.outlookFlag || contact.companyDirectoryFlag || contact.o365Flag || contact.personalDirectoryFlag || contact.phonebookDirectoryFlag) { return contact; }
        if (contact.dbId) {
            try { await this.getContactByDBId(contact.dbId, true); }
            catch (error) { throw new Error(error.message); }
        }
        return contact;
    }

    // ----------------------------------
    //      SETTINGS  STUFF
    // ----------------------------------

    private async getUserSettings() {
        try {
            this.logger.info("[ContactService] GetUserSettings");
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/users/${this.userContact.dbId}/settings`;
            const headers = this.authService.getRequestHeader();
            const response: Response = await fetch(url, { method: 'GET', headers });
            if (!response.ok) throw (response);
            const responseData = await response.json();
            const presence = (responseData.data.presence && this.userContact.changePresenceEnabled) ? responseData.data.presence : "online";
            const activeAlarm = responseData.data.activeAlarm || "relax1";
            const activeNotif = responseData.data.activeNotif || "notif1";
            const ringingOnDnd = responseData.data.ringingOnDnd;//RQRAINB-4880
            const promptForCalendarPresence = responseData.data.promptForCalendarPresence;
            const protectionAgainstMailTypeOffline = responseData.data.protectionAgainstMailTypeOffline;
            const applyCalendarPresence = Boolean(responseData.data.applyCalendarPresence);
            const applyMsTeamsPresence = Boolean(responseData.data.applyMsTeamsPresence);
            const autoAnswer = responseData.data.autoAnswer || false;
            const autoAnswerByDeviceType = responseData.data.autoAnswerByDeviceType || "desktop";
            const displayOrder = (responseData.data.displayNameOrderFirstNameFirst === true) ? "FL" : "LF";
            const displaySecretIdentityService = Boolean(responseData.data.displaySecretIdentityService);
            const rejectOnBusy = Boolean(responseData.data.rejectOnBusy);
            const capabilityWRGConvShift = Boolean(responseData.data.capabilityWRGConvShift);
            //RQRAINB-12331++
            this.userContact.oxePreferredTrunk = responseData.data.preferredTrunk ? responseData.data.preferredTrunk : -1; //the index of the preferred oxe trunk (-1 is the default value corresponding to default oxe trunk)
            if (responseData.data.trunkPrefixes?.length) {
                this.userContact.oxeTrunks = responseData.data.trunkPrefixes; //the list of oxe trunks available (optional)
                this.logger.info("[ContactService] getUserSettings - preferredTrunk updated");
                this.sendInnerEvent(ContactServiceEvents.ON_CONNECTED_USER__OXEPREFERREDTRUNK_CHANGE, this.userContact.oxePreferredTrunk);
            }
            //RQRAINB-12331--
            this.logger.info("[ContactService] GetUserSettings success");
            const settings = { presence, activeAlarm, activeNotif, ringingOnDnd, promptForCalendarPresence, protectionAgainstMailTypeOffline, applyCalendarPresence, autoAnswer, autoAnswerByDeviceType, applyMsTeamsPresence, displayOrder, displaySecretIdentityService, rejectOnBusy };

            //update settings received from API
            this.manageCalendarPresencePrompt(settings);
            this.settingsService.setSetting('activeAlarm', settings.activeAlarm);
            this.settingsService.setSetting('activeNotif', settings.activeNotif);
            this.settingsService.setSetting('ringingOnDnd', settings.ringingOnDnd);//RQRAINB-4880
            this.settingsService.setSetting('protectionAgainstMailTypeOffline', settings.protectionAgainstMailTypeOffline);
            this.settingsService.setSetting('applyCalendarPresence', String(settings.applyCalendarPresence));
            this.settingsService.setSetting('applyMsTeamsPresence', String(settings.applyMsTeamsPresence));
            this.settingsService.setSetting('autoAnswer', settings.autoAnswer);
            this.settingsService.setSetting('presence', settings.presence);
            this.settingsService.setSetting('autoAnswerByDeviceType', String(settings.autoAnswerByDeviceType));
            this.settingsService.setSetting('displayOrder', settings.displayOrder);
            this.settingsService.setSetting('displaySecretIdentityService', String(settings.displaySecretIdentityService));
            this.settingsService.setSetting('rejectOnBusy', String(settings.rejectOnBusy));
            this.settingsService.setSetting('capabilityWRGConvShift', String(capabilityWRGConvShift));
            this.logger.info("[ContactService] Get alarm & notif data (" + settings.activeAlarm + " / " + settings.activeNotif + ")");
            this.logger.info("[ContactService] Get mail setting data (" + settings.protectionAgainstMailTypeOffline + ")");

            if (capabilityWRGConvShift) { this.logger.info(`[ContactService] GetUserSettings -- capabilityWRGConvShift is enabled`); }

            return settings;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getUserSettings');
            this.logger.error(errorInfo.message);
            return { presence: "online", activeAlarm: "relax1", activeNotif: "notif1", ringingOnDnd: false, promptForCalendarPresence: false, autoAnswer: false, autoAnswerByDeviceType: "desktop" };
        }
    }

    public getUserSettingFromSettingsService(settings: string) {
        return this.settingsService.getSetting(settings);
    }

    // --------------------------------
    //      LAST ACTIVITY  STUFF
    // --------------------------------

    public async getContactLastActivityDate(contact: Contact): Promise<void> {
        if (contact.lastActivityDate.value !== null) return;

        if (!this.lastActivityDatePromises[contact.id]) {
            this.lastActivityDatePromises[contact.id] = new Promise<void>((resolve, reject) => {
                try {
                    this.xmppService.connection.lastactivity.query(contact.jid, {
                        onResponse: (stanza: any) => {
                            const inactivityInSeconds = Number.parseInt(xmlParser(stanza).find("query").attr("seconds"), 10);
                            const lastActivityDate = subSeconds(new Date(), inactivityInSeconds);
                            this.updateContactLastActivityDate(contact, lastActivityDate);
                            resolve();
                            delete this.lastActivityDatePromises[contact.id];
                        }
                    });
                }
                catch (error) {
                    reject(new Error(`[ContactService] getInitialContactLastActivityMessage -- Failure -- ${error.message}`));
                    delete this.lastActivityDatePromises[contact.id];
                }
            });
        }
    }

    private updateLastActivity(contact: Contact) {
        let lastActivityDate = null;
        if (contact.status === "offline" || contact.status === "away") {
            Object.keys(contact.imStatusStamp).forEach((key) => {
                const stamp = contact.imStatusStamp[key];
                if (!lastActivityDate || lastActivityDate < stamp) { lastActivityDate = stamp; }
            });
        }
        this.updateContactLastActivityDate(contact, lastActivityDate);
    }

    private updateContactLastActivityDate(contact: Contact, lastActivityDate: Date | null) {
        contact.lastActivityDate.next(lastActivityDate);
    }

    // ----------------------------------
    //      CALENDAR STUFF
    // ----------------------------------

    /**
     * Update the user auto dnd calendar settings. If activated, and if the user is sharing with
     * Rainbow his current calendar (Office 365 or Google Calendar), the presence will automatically go to DND
     * in case of a meeting scheduled in the calendar.
     * NB: The user can "exit" the current DND state by simply changing his presence (this will not
     *      deactivate the settings, but will "disable" it for the current meeting, until the next one)
     * NB: The change of the parameter does not affect the current meeting! It's taken into account for the next one
     * @param activate - boolean that will activate / deactivate the settings
     */
    public async updateUserAutoDndCalendarSetting(activate: boolean): Promise<boolean> {
        await this.setUserSettings({ applyCalendarPresence: activate });
        return activate;
    }

    /**
     * Get the user auto dnd calendar settings. If activated, and if the user is sharing with
     * Rainbow his current calendar (Office 365 or Google Calendar), the presence will automatically go to DND
     * in case of a meeting scheduled in the calendar. For more information check updateUserAutoDndCalendarSetting API
     */
    public getUserAutoDndCalendarSetting(): boolean {
        const result = this.getUserSettingFromSettingsService("applyCalendarPresence");
        return (result === "true");
    }

    private manageCalendarPresencePrompt(settings: any) {
        // Fetch promptForCalendarPresnce settings
        if (settings.promptForCalendarPresence !== undefined) {
            this.settingsService.setSetting("disableCalendarPresence", settings.promptForCalendarPresence ? "false" : "true");
            this.logger.info("[ContactService] promptForCalendarPresence -- " + settings.promptForCalendarPresence);
        }
        else {
            const promptForCalendarPresence = this.settingsService.getSetting("disableCalendarPresence") !== "true";
            this.logger.info("[ContactService] MIGRATION NECESSARY -- promptForCalendarPresence : " + promptForCalendarPresence);
            this.setUserSettings({ promptForCalendarPresence: promptForCalendarPresence });
        }
    }

    // ----------------------------------
    //      MS TEAM   STUFF
    // ----------------------------------

    /**
     * Update the user MS Teams presence calendar settings. If activated, and if the user is sharing with
     * Rainbow his current calendar (Office 365), the presence from his MS Teams client is managed and the Rainbow application
     * will go to busy or DND in case the presence in teams change;
     * @param activate - boolean that will activate / deactivate the settings
     */
    public async updateUserMSTeamsPresenceSetting(activate: boolean): Promise<boolean> {
        await this.setUserSettings({ applyMsTeamsPresence: activate });
        return activate;
    }

    /**
     * Get the user MS Teams presence calendar settings. If activated, and if the user is sharing with
     * Rainbow his current calendar (Office 365), the presence from his MS Teams client is managed and the Rainbow application
     * will go to busy or DND in case the presence in his Teams client change;
     */
    public getUserMSTeamsPresenceSetting(): boolean {
        const result = this.getUserSettingFromSettingsService("applyMsTeamsPresence");
        return (result === "true");
    }

    // ----------------------------------------------------
    //      CONNECTED USER 'WebRTC Capabilities'   STUFF
    // ----------------------------------------------------

    /**
     * Get the capabilities representing the medias that could be used for a WebRTC Call with the specified remote Rainbow user.
     */
    public getConnectedUserWebRTCCallCapabilities(remoteParty: User): WebCallCapabilities {
        let canMakeAudio: boolean = false;
        let canMakeVideo: boolean = false;
        let canMakeSharing: boolean = false;

        // First, check conditions applicable to all types of media
        if (!(remoteParty !== this.userContact // Called user is not the Connected user
            && (remoteParty as Contact)?.capabilities?.webRTC && !(remoteParty as Contact)?.capabilities.addMedia // Criteria on called user capabilities
            && this.userContact?.capabilities?.webRTC)) // Criteria on Connected user capabilities
        {
            return { audio: false, video: false, sharing: false };
        }

        // Second, check webRTC media capability
        // Check audio capability (On both connected + remote users)
        canMakeAudio = this?.userContact.webrtcAudioEnabled && (remoteParty as Contact)?.webrtcAudioEnabled;

        // Check video capability (On both connected + remote users)
        canMakeVideo = this?.userContact.webrtcVideoEnabled && (remoteParty as Contact)?.webrtcVideoEnabled;

        // Check browser validity (connected user only)
        canMakeSharing = this?.userContact?.webrtcSharingEnabled && (window.adapter?.browserDetails.browser !== 'safari');

        return {
            audio: canMakeAudio,
            video: canMakeVideo,
            sharing: canMakeSharing,
        };
    }

    public createWebRTCCapabilitiesObservable(remoteParty: User): Observable<WebCallCapabilities> {
        return new Observable<WebCallCapabilities>((observer) => {
            // Sending new WebRTC call capabilities between the connected user and the specified user
            let remotePartySubscription: Subscription;
            let connectedUserSubscription: Subscription;

            try {
                const emitWebRTCCallCapabilities = () => {
                    const callCapabilities: WebCallCapabilities = this.getConnectedUserWebRTCCallCapabilities(remoteParty);
                    observer.next(callCapabilities);
                };

                // this.logger.debug(`[contactService] createWebRTCCapabilitiesObservable -- Return the 1st Web Call Capabilities values !`);
                emitWebRTCCallCapabilities();

                // Subscription on connected user instance
                connectedUserSubscription = this.userContact.rxSubject.subscribe((event) => {
                    try {
                        this.logger.debug(`[contactService] connectedUserSubscription -- event = ${event?.name}`);
                        emitWebRTCCallCapabilities();
                    }
                    catch (error) {
                        observer.error(error);
                    }
                });

                // Subscription on remote party user instance
                remotePartySubscription = (remoteParty as Contact)?.rxSubject.subscribe((event) => {
                    try {
                        this.logger.debug(`[contactService] remotePartySubscription -- event = ${event?.name}`);
                        emitWebRTCCallCapabilities();
                    }
                    catch (error) {
                        observer.error(error);
                    }
                });
                // throw new Error('[contactService]  Error simulation code to stop it all !');
            }
            catch (error) {
                observer.error(error);
            }

            // Cleaning
            return () => {
                this.logger.error(`[contactService] createWebRTCCapabilitiesObservable -- Clean all subscriptions !`);
                connectedUserSubscription.unsubscribe();
                remotePartySubscription.unsubscribe();
            };
        });
    }

    // ------------------------------------------
    //  NOTIFICATION UTILITIES (Mail, Desktop)
    // ------------------------------------------

    public async notifyImByEmail(contact: Contact) {
        let responseData = null;
        try {
            const url = `${config.restServerUrl}/api/rainbow/enduser/v1.0/notifications/emails/offline`;
            const headers = this.authService.getPostHeader();
            const response: Response = await fetch(url, { method: 'POST', headers, body: JSON.stringify({ userId: contact.dbId }) });
            if (!response.ok) throw (response);
            responseData = await response.json();

            let mail = "";
            if (responseData.data?.email) {
                mail = responseData.data.email.substr(0, 3) + "***" + responseData.data.email.substr(-3);
            }
            this.logger.info("[ContactService] notifyImByEmail " + mail + " - success");
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'notifyImByEmail');
            this.logger.error(errorInfo.message);
            throw errorInfo.error;
        }
    }

    public shouldShowNotification(): boolean {
        let show = true;

        //do not show notification if DND, or busy + DND (PBX hyntid case) or busy + sharing (Webrtc or conference case)
        if (this.userContact.status === "dnd" || (this.userContact.status === "busy" && this.dndStateActivated) || (this.busyState.status === "busy" && this.busyState.message === "sharing")) {
            show = false;
        }

        return show;
    }

    // ------------------------------------------
    //          VARIOUS UTILITIES STUFF
    // ------------------------------------------

    //  JID UTILITIES
    // ----------------------
    public isTelJid(jid: string): boolean {
        return jid.indexOf("tel_") === 0;
    }

    public isMediaPillarJid(jid: string) {
        return (jid && jid.indexOf("mp_") === 0);
    }

    public isUserContact(contact: Contact | User): boolean {
        return (!contact?.jid) ? false : this.isUserContactJid(contact.jid);
    }

    public isUserContactJid(jid: string): boolean {
        return (!this.userContact || !jid || jid.length === 0) ? false : jid.startsWith(this.userContact.jid);
    }

    public getResourceFromJid(jid: string) {
        return this.xmppService.getResourceFromJid(jid);
    }

    public getImJid(jid: string) {
        const bareJid = this.xmppService.getBareJidFromJid(jid);
        if (this.isTelJid(bareJid)) {
            const contact = this.jtelContacts[bareJid];
            if (contact) { return contact.jid; }

            //try to find the contact by his jid, and not jid tel
            const jidim = bareJid.replace("tel_", "");
            if (this.contacts[jidim]) return jidim;

            this.logger.warn("[ContactService] -- getIMJid(" + jid + ") -- failure -- no associated contact");
            return null;
        }
        return bareJid;
    }

    //  OTHER UTILITIES
    //  NOTE : If you think so and according to your expertise,
    //         these methods can be reclassified for greater consistency.
    // ------------------------------------------------------------------

    public isSingleComputerClient() {
        const instancesWebDesk = Object.keys(this.userContact.resources).filter((contact) => {
            return contact.indexOf("web_") !== -1 || contact.indexOf("desk_") !== -1;
        });
        this.logger.info("[ContactService] isSingleComputerClient clients number : " + instancesWebDesk.length);
        return instancesWebDesk.length <= 1;
    }

    public myMobileAvailable() {
        return this.userContact ? this.userContact.mobileResource : null;
    }

    public contactMatcher(contact: Contact, criteria: string) {
        const displayname = contact.firstname + " " + contact.lastname;
        const queries = criteria.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(/[ ]+/);
        const names = displayname.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(/[ ]+/);
        return queries.every((query) => {
            return names.some((name, index) => {
                if (name.length && name.indexOf(query) === 0) { names[index] = ""; return true; }
                return false;
            });
        });
    }

}
